<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import groupBy from "lodash/groupBy";
import cloneDeep from "lodash/cloneDeep";
import DatePicker from "vue2-datepicker";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import MaskedInput from "vue-text-mask";
import FundCluster from "@/components/modals/fund-cluster-list.vue";
import ItemCategory from "@/components/modals/item-category.vue";
import Supplier from "@/components/modals/supplier.vue";
import Unit from "@/components/modals/unit.vue";
import Employee from "@/components/modals/employee-hris.vue";
import Location from "@/components/modals/property-location.vue";
import Campus from "@/components/modals/campus.vue";
import Inventory from "@/components/modals/property-inventory.vue";
import PrintOptions from "@/components/modals/print-options.vue";
import PropertyUpdate from "@/components/modals/property-create.vue";
import Details from "@/router/views/property/components/details";
import AssignmentHistory from "@/router/views/property/components/assignmenthistory";
import CurrentInventory from "@/router/views/property/components/inventory";
import InspectionHistory from "@/router/views/property/components/inspectionhistory";
import Attachments from "@/router/views/property/components/attachments";
import RawData from "@/components/widgets/raw-data.vue";

export default {
  page: {
    title: "Properties"
  },
  components: {
    Layout,
    PageHeader,
    DatePicker,
    MaskedInput,
    FundCluster,
    ItemCategory,
    Supplier,
    Unit,
    Employee,
    Location,
    Campus,
    Inventory,
    PrintOptions,
    PropertyUpdate,
    Details,
    AssignmentHistory,
    CurrentInventory,
    InspectionHistory,
    Attachments,
    RawData
  },
  data() {
    return {
      title: "Properties",
      submitted: false,
      items: [
        {
          text: "Dashboards",
          href: "/"
        },
        {
          text: "Properties",
          active: true
        }
      ],
      currencyMask: createNumberMask({
        prefix: "",
        allowDecimal: true
      }),
      quantityMask: createNumberMask({
        prefix: "",
        includeThousandsSeparator: false
      }),
      percentMask: createNumberMask({
        prefix: "",
        suffix: "%",
        allowDecimal: true,
        integerLimit: 2,
        includeThousandsSeparator: false
      }),
      tableData: [],
      employeeData: null,
      modalTitle: "",
      currentPage: 1,
      perPage: 10,
      pageOptionsLg: [10, 25, 50, 100],
      pageOptionsSm: [5, 10, 20, 50],
      filter: "",
      sortBy: "id",
      sortDesc: true,
      fields: [
        {
          key: "poNumber",
          sortable: true,
          label: "Purchase Order"
        }
      ],
      propertyFields: [
        {
          key: "Name",
          sortable: true
        }
      ],
      sideBarPrint: true,
      poNumber: "",
      propertyNumber: "",
      propertyName: "",
      employeeId: "",
      employeeIdNumberPrint: "",
      employeeNamePrint: "",
      locationIdPrint: "",
      locationNamePrint: "",
      assignmentNumber: "",
      fundCluster: "",
      fundClusterId: 0,
      fundClusterGet: "",
      getClusterType: "",
      itemCategoryId: 0,
      itemYear: null,
      locationIdSelected: 0,
      campusId: this.$store.state.data.selectedCampus.id,
      campusSelected: null,
      inventorySelected: null,
      inventoryTitle: "",
      minCost: "",
      maxCost: "",
      getBy: 1,
      getByValue: 1,
      getByPrint: 1,
      bySearch: true,
      byFiltered: false,
      byAll: false,
      selectedProperties: JSON.parse(localStorage.getItem("selectedProperties")) || [],
      perPageCart: 10,
      currentPageCart: 1,
      filterCart: "",
      mouseOverCart: false,
      transferForm: {
        propertyTransferItems: [],
        campusId: this.campusId,
        type: "",
        reason: "",
        assignmentNote: "",
        fromEmployeeId: null,
        transferToEmployeeId: null,
        employeeName: "",
        remarks: "",
        location: "",
        locationId: 0,
        toggleAll: false
      },
      returnForm: {
        id: null,
        returnNotes: "",
        dateReturned: ""
      },
      poIndex: -1,
      propertyIndex: -1,
      itemIndex: -1,
      tableBusy: false,
      itemCategory: "",
      itemCategoryGet: "",
      employeeName: "",
      employeeNameGet: "",
      getEmployeeType: "",
      getCategoryType: "",
      getLocationType: "",
      getLocationItem: null,
      location: "",
      locationGet: "",
      campus: "",
      itemCategoryIdChange: null,
      itemCategoryChange: "",
      dateAcquiredChange: null,
      dateAssignedChange: null,
      unitCostChange: "",
      locationIdChange: null,
      locationChange: "",
      conditionChange: "",
      accountableEmployee: null,
      multipleUpdateType: "",
      assignmentHistoryEmployeeData: null,
      assignmentHistoryLocationData: null,
      tabIndex: 0,
      rpType: "rpcppe",
      showEOL: true,
      showConsumables: true,
      newItemAdded: false
    };
  },
  computed: {
    grouped() {
      if (this.byFiltered) {
        var array = [];
        var x = groupBy(this.filtered, "supplier");
        for (const key in x) {
          var supplier = key;
          var y = groupBy(x[key], "poNumber");
          for (const key in y) {
            array.push({
              poNumber: key,
              supplier: supplier,
              details: y[key],
              toggleAll: false,
              showDetails: false,
              rotateChevy: false,
              currentPage: 1,
              perPage: 5,
              filter: "",
              tableBusy: false
            });
          }
        }
        return array;
      } else return this.filtered;
    },
    filtered() {
      let data = this.tableData;
      if (this.filter.trim() != "" && this.filter) {
        data = data.filter((item) => {
          if (this.bySearch) {
            if (
              item.poNumber.toUpperCase().includes(this.filter.toUpperCase())
            ) {
              return item.poNumber
                .toUpperCase()
                .includes(this.filter.toUpperCase());
            } else if (
              item.supplier.toUpperCase().includes(this.filter.toUpperCase())
            ) {
              return item.supplier
                .toUpperCase()
                .includes(this.filter.toUpperCase());
            } else if (
              item.name.toUpperCase().includes(this.filter.toUpperCase())
            ) {
              return item.name
                .toUpperCase()
                .includes(this.filter.toUpperCase());
            } else if (
              item.propertyNumber
                .toUpperCase()
                .includes(this.filter.toUpperCase())
            ) {
              return item.propertyNumber
                .toUpperCase()
                .includes(this.filter.toUpperCase());
            } else if (
              item.serialNumber
                .toUpperCase()
                .includes(this.filter.toUpperCase())
            ) {
              return item.serialNumber
                .toUpperCase()
                .includes(this.filter.toUpperCase());
            } else if (
              item.currentAssignment &&
              item.currentAssignment.assignmentNumber &&
              item.currentAssignment.assignmentNumber
                .toUpperCase()
                .includes(this.filter.toUpperCase())
            ) {
              return item.currentAssignment.assignmentNumber
                .toUpperCase()
                .includes(this.filter.toUpperCase());
            }
          } else {
            if (
              item.poNumber.toUpperCase().includes(this.filter.toUpperCase())
            ) {
              return item.poNumber
                .toUpperCase()
                .includes(this.filter.toUpperCase());
            } else if (
              item.supplier.toUpperCase().includes(this.filter.toUpperCase())
            ) {
              return item.supplier
                .toUpperCase()
                .includes(this.filter.toUpperCase());
            }
          }
        });
      }
      return data;
    },
    rows() {
      return this.grouped.length;
    },
    filteredCart() {
      let data = this.selectedProperties;
      if (this.filterCart.trim() != "" && this.filterCart) {
        data = data.filter((item) => {
          if (item.propertyName.toUpperCase().includes(this.filterCart.toUpperCase())) {
            return item.propertyName
              .toUpperCase()
              .includes(this.filterCart.toUpperCase());
          } else if (
            item.propertyNumber
              .toUpperCase()
              .includes(this.filterCart.toUpperCase())
          ) {
            return item.propertyNumber
              .toUpperCase()
              .includes(this.filterCart.toUpperCase());
          }
        });
      }
      return data;
    },
    rowsCart() {
      if (this.filterCart.trim() != "" && this.filterCart) {
        return this.filteredCart.length;
      } else {
        return this.selectedProperties.length;
      }
    },
    compareCost() {
      if (
        parseFloat(this.getExactAmt(this.minCost)) >
        parseFloat(this.getExactAmt(this.maxCost)) ||
        (this.getExactAmt(this.minCost) != "" &&
          this.getExactAmt(this.maxCost) == "")
      )
        return 1;
      else return 0;
    },
    isICFEmployee(){
      if(this.getByPrint == 2){
        return true;
      }
      if(this.getByPrint == 5){
        return true;
      }
      if(this.getByPrint == 6){
        return true;
      }
      return false;
    }
  },
  created() {
    this.changeCampus(this.$store.state.data.selectedCampus);
    this.getMyCart();
  },
  methods: {
    async getMyCart() {
      try{
        const { data: response } = await this.$store.dispatch("propertycart/GetMyCart");
        if(response.error){
          this.showToast(response.errorMessage, "error");
          return;
        }
        response.map(item => {
          item.name = item.propertyName;
          item.amount = JSON.parse(JSON.stringify(item.currentValue));
        })
        this.selectedProperties = response;
      }catch{
        this.showToast("Something went wrong - Getting cart items!", "error");
      }
    },
    changeCampus(data) {
      this.campusId = data.id;
      this.getProperties();
    },
    propertyFiltered(row) {
      let data = row.details;
      if (row.filter.trim() != "" && row.filter) {
        data = data.filter((item) => {
          if (item.name.toUpperCase().includes(row.filter.toUpperCase())) {
            return item.name.toUpperCase().includes(row.filter.toUpperCase());
          } else if (
            item.propertyNumber.toUpperCase().includes(row.filter.toUpperCase())
          ) {
            return item.propertyNumber
              .toUpperCase()
              .includes(row.filter.toUpperCase());
          } else if (
            item.serialNumber.toUpperCase().includes(row.filter.toUpperCase())
          ) {
            return item.serialNumber
              .toUpperCase()
              .includes(row.filter.toUpperCase());
          } else if (
            item.currentAssignment &&
            item.currentAssignment.assignmentNumber
              .toUpperCase()
              .includes(row.filter.toUpperCase())
          ) {
            return item.currentAssignment.assignmentNumber
              .toUpperCase()
              .includes(row.filter.toUpperCase());
          }
        });
      }
      return data;
    },
    propertyRows(row) {
      if (row.filter.trim() != "" && row.filter) {
        return this.propertyFiltered(row).length;
      } else {
        return row.details.length;
      }
    },
    getProperties() {
      this.getByValue = null;
      setTimeout(() => {
        this.getByValue = this.getBy;
      }, 600);
      this.tableData = [];
      this.employeeData = null;
      this.currentPage = 1;
      this.perPage = 10;
      this.filter = "";
      if (this.getBy == 1) {
        this.byAll = false;
        setTimeout(() => {
          this.bySearch = true;
        }, 400);
      } else if (this.getBy == 2) {
        this.bySearch = false;
        setTimeout(() => {
          this.byAll = true;
          this.getByPo();
        }, 400);
      }
    },
    checkSearchInput() {
      if (
        this.compareCost == 1 ||
        (this.poNumber == "" &&
          this.propertyNumber == "" &&
          this.propertyName == "" &&
          this.employeeId == "" &&
          this.assignmentNumber == "" &&
          this.locationIdSelected == 0 &&
          this.fundCluster == "" &&
          this.itemCategoryId == 0 &&
          this.itemYear == "" &&
          this.minCost == "" &&
          this.maxCost == "")
      )
        return true;
      else return false;
    },
    getBySearch() {
      // if (this.checkSearchInput()) {
      //   this.showToast("Invalid search parameter.", "warning");
      //   return;
      // }
      this.tableBusy = true;
      window.scrollTo(0, 0);
      var poNumber = this.poNumber.trim();
      var propertyNumber = this.propertyNumber.trim();
      var propertyName = this.propertyName;
      var employeeIdNumber = this.employeeId.trim();
      var parIcsNumber = this.assignmentNumber.trim();
      var campusId = this.campusId;
      var propertyLocationId = this.locationIdSelected;
      var fundCluster = this.fundCluster.trim();
      var itemCategoryId = this.itemCategoryId;
      var year = 0;
      if (this.itemYear != null && this.itemYear != "") {
        year = this.itemYear.getFullYear();
      }
      var unitCostMin = 0;
      if (
        this.getExactAmt(this.minCost) != null &&
        this.getExactAmt(this.minCost) != ""
      ) {
        unitCostMin = this.getExactAmt(this.minCost);
      }
      var unitCostMax = 0;
      if (
        this.getExactAmt(this.maxCost) != null &&
        this.getExactAmt(this.maxCost) != ""
      ) {
        unitCostMax = this.getExactAmt(this.maxCost);
      }
      this.$store
        .dispatch("property/GetPropertybySearch", {
          poNumber,
          propertyNumber,
          propertyName,
          employeeIdNumber,
          parIcsNumber,
          campusId,
          propertyLocationId,
          fundCluster,
          itemCategoryId,
          year,
          unitCostMin,
          unitCostMax,
          showEOL: this.showEOL,
          showConsumables: this.showConsumables,
          removeLoading: true
        })
        .then((res) => {
          res.data.forEach((item) => {
            item.visible = false;
            item.itemVisible = false;
            item.assignmentHistory = [];
            item.assignVisible = false;
            item.assignLoading = false;
            item.inventory = [];
            item.inventoryVisible = false;
            item.inventoryLoading = false;
            item.inspectionVisible = false;
            item.attachmentVisible = false;
            item.attachmentLoading = false;
            item.addDocu = false;
            item.fileSearch = "";
            item.propertyInspections.forEach((inspect) => {
              inspect.inspectionFiles = [];
              inspect.attachmentLoading = false;
            });
          });
          this.tableData = res.data;
          this.employeeData = null;
          if (employeeIdNumber != "") this.getEmployeeInfo();
          this.tableBusy = false;
        })
        .catch(() => {
          this.tableBusy = false;
          this.showToast(
            "Something went wrong - Getting property list!",
            "error"
          );
        });
    },
    getByPo() {
      this.tableBusy = true;
      this.$store
        .dispatch("property/GetPropertyPosted", this.campusId)
        .then((res) => {
          res.data.forEach((item) => {
            item.details = [];
            item.showDetails = false;
            item.rotateChevy = false;
            item.currentPage = 1;
            item.perPage = 5;
            item.filter = "";
            item.tableBusy = false;
          });
          this.tableData = res.data;
          this.tableBusy = false;
        })
        .catch(() => {
          this.tableBusy = false;
          this.showToast(
            "Something went wrong - Getting property list!",
            "error"
          );
        });
    },
    getProperty(row) {
      row.item.rotateChevy = !row.item.rotateChevy;
      row.item.showDetails = !row.item.showDetails;
      if (!this.bySearch) {
        row.item.details = [];
        if (row.item.showDetails) {
          row.item.tableBusy = true;
          setTimeout(() => {
            var poNumber = row.item.poNumber;
            var status = "POSTED";
            var campusId = this.campusId;
            this.$store
              .dispatch("property/GetPropertybyPO", {
                poNumber,
                status,
                campusId
              })
              .then((res) => {
                res.data.forEach((item) => {
                  item.visible = false;
                  item.itemVisible = false;
                  item.assignmentHistory = [];
                  item.assignVisible = false;
                  item.assignLoading = false;
                  item.inventory = [];
                  item.inventoryVisible = false;
                  item.inventoryLoading = false;
                  item.inspectionVisible = false;
                  item.attachmentVisible = false;
                  item.attachmentLoading = false;
                  item.addDocu = false;
                  item.fileSearch = "";
                  item.propertyInspections.forEach((inspect) => {
                    inspect.inspectionFiles = [];
                    inspect.attachmentLoading = false;
                  });
                });
                row.item.details = res.data;
                row.item.tableBusy = false;
              })
              .catch(() => {
                row.item.tableBusy = false;
                this.showToast(
                  "Something went wrong - Getting property list!",
                  "error"
                );
              });
          }, 1000);
        }
      }
    },
    getEmployeeInfo() {
      this.$store
        .dispatch("externalemployee/GetByEmployeeId", this.employeeId.trim())
        .then((res) => {
          this.employeeData = res.data;
        });
    },
    async printIcsEmployee() {
      if (
        this.employeeIdNumberPrint == "" ||
        this.employeeIdNumberPrint == null
      ) {
        return;
      } else {
        var apiUrl = `api/Report/Property/ICS/AccountableOfficer`;
        var routeVariables = [this.employeeIdNumberPrint];
        this.$refs.printOpt.putOptions({
          apiUrl: apiUrl,
          routeVariables: routeVariables
        });
        this.$bvModal.show("print-options-modal");
      }
    },
    async printIcsPoAndEmployee(poNumber, id) {
      if (
        poNumber.trim() == "" ||
        poNumber.trim() == "." ||
        poNumber.toLowerCase() == "not indicated" ||
        !poNumber
      ) {
        this.showToast(
          "Selected property/ies does not have a PO number.",
          "warning"
        );
      } else {
        var apiUrl = `api/Report/Property/ICS/PO/AccountableOfficer`;
        var routeVariables = [poNumber, id];
        this.$refs.printOpt.putOptions({
          apiUrl: apiUrl,
          routeVariables: routeVariables
        });
        this.$bvModal.show("print-options-modal");
      }
    },
    async printIcsPo(poNumber) {
      if (
        poNumber.trim() == "" ||
        poNumber.trim() == "." ||
        poNumber.toLowerCase() == "not indicated" ||
        !poNumber
      ) {
        this.showToast(
          "Selected property/ies does not have a PO number.",
          "warning"
        );
      } else {
        var apiUrl = `api/Report/Property/ICS/PO`;
        var routeVariables = [poNumber];
        this.$refs.printOpt.putOptions({
          apiUrl: apiUrl,
          routeVariables: routeVariables
        });
        this.$bvModal.show("print-options-modal");
      }
    },
    async printIcsProperty(id) {
      var apiUrl = `api/Report/Property/ICS`;
      var routeVariables = [];
      var body = [];
      body.push(id);
      this.$refs.printOpt.putOptions({
        apiUrl: apiUrl,
        routeVariables: routeVariables,
        body: body
      });
      this.$bvModal.show("print-options-modal");
    },
    async printIcsMultiple() {
      var apiUrl = `api/Report/Property/ICS`;
      var routeVariables = [];
      var body = [];
      this.filteredCart.forEach((item) => {
        body.push(item.propertyId);
      });
      this.$refs.printOpt.putOptions({
        apiUrl: apiUrl,
        routeVariables: routeVariables,
        body: body
      });
      this.$bvModal.show("print-options-modal");
    },
    async printParEmployee() {
      if (
        this.employeeIdNumberPrint == "" ||
        this.employeeIdNumberPrint == null
      ) {
        return;
      } else {
        var apiUrl = `api/Report/Procurement/Property/PAR/AccountableOfficer`;
        var routeVariables = [this.employeeIdNumberPrint];
        this.$refs.printOpt.putOptions({
          apiUrl: apiUrl,
          routeVariables: routeVariables
        });
        this.$bvModal.show("print-options-modal");
      }
    },
    async printParPoAndEmployee(poNumber, id) {
      if (
        poNumber.trim() == "" ||
        poNumber.trim() == "." ||
        poNumber.toLowerCase() == "not indicated" ||
        !poNumber
      ) {
        this.showToast(
          "Selected property/ies does not have a PO number.",
          "warning"
        );
      } else {
        var apiUrl = `api/Report/Procurement/PAR/PO/AccountableOfficer`;
        var routeVariables = [poNumber, id];
        this.$refs.printOpt.putOptions({
          apiUrl: apiUrl,
          routeVariables: routeVariables
        });
        this.$bvModal.show("print-options-modal");
      }
    },
    async printParPo(poNumber) {
      if (
        poNumber.trim() == "" ||
        poNumber.trim() == "." ||
        poNumber.toLowerCase() == "not indicated" ||
        !poNumber
      ) {
        this.showToast(
          "Selected property/ies does not have a PO number.",
          "warning"
        );
      } else {
        var apiUrl = `api/Report/Procurement/PAR/PO`;
        var routeVariables = [poNumber];
        this.$refs.printOpt.putOptions({
          apiUrl: apiUrl,
          routeVariables: routeVariables
        });
        this.$bvModal.show("print-options-modal");
      }
    },
    async printParProperty(id) {
      var apiUrl = `api/Report/Property/PAR`;
      var routeVariables = [];
      var body = [];
      body.push(id);
      this.$refs.printOpt.putOptions({
        apiUrl: apiUrl,
        routeVariables: routeVariables,
        body: body
      });
      this.$bvModal.show("print-options-modal");
    },
    async printParMultiple() {
      var apiUrl = `api/Report/Property/PAR`;
      var routeVariables = [];
      var body = [];
      this.filteredCart.forEach((item) => {
        body.push(item.propertyId);
      });
      this.$refs.printOpt.putOptions({
        apiUrl: apiUrl,
        routeVariables: routeVariables,
        body: body
      });
      this.$bvModal.show("print-options-modal");
    },
    async printStickerPo(poNumber) {
      if (
        poNumber.trim() == "" ||
        poNumber.trim() == "." ||
        poNumber.toLowerCase() == "not indicated" ||
        !poNumber
      ) {
        this.showToast(
          "Selected property/ies does not have a PO number.",
          "warning"
        );
      } else {
        var apiUrl = `api/Report/Property/Property/Sticker`;
        var routeVariables = [poNumber];
        this.$refs.printOpt.putOptions({
          apiUrl: apiUrl,
          routeVariables: routeVariables
        });
        this.$bvModal.show("print-options-modal");
      }
    },
    async printStickerProperty(propertyId) {
      var apiUrl = `api/Report/Property/Property/Sticker/Property`;
      var routeVariables = [propertyId];
      this.$refs.printOpt.putOptions({
        apiUrl: apiUrl,
        routeVariables: routeVariables
      });
      this.$bvModal.show("print-options-modal");
    },
    async printPropertyCard(propertyId) {
      var apiUrl = `api/Report/Property/Property/Card`;
      var routeVariables = [propertyId];
      this.$refs.printOpt.putOptions({
        apiUrl: apiUrl,
        routeVariables: routeVariables,
        body: { propertyId }
      });
      this.$bvModal.show("print-options-modal");
    },
    async printStickerMultiple() {
      var apiUrl = `api/Report/Property/Property/Sticker/Properties`;
      var routeVariables = [];
      var body = [];
      if (this.filteredCart.length > 100) {
        this.$swal({
          title: "More than 100 items are selected.",
          text: "The first 100 items will be printed and be removed from cart.",
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#f46a6a",
          confirmButtonText: "Proceed",
          allowOutsideClick: false
        }).then((result) => {
          if (result.isConfirmed) {
            this.filteredCart.sort((a, b) => b.propertyId - a.propertyId);
            for (var counter = 0; counter < 100; counter++) {
              body.push(this.filteredCart[counter].propertyId);
            }
            this.$refs.printOpt.putOptions({
              apiUrl: apiUrl,
              routeVariables: routeVariables,
              body: body
            });
            this.$bvModal.show("print-options-modal");
            this.$nextTick(() => {
              this.filteredCart.splice(0, 100);
            });
          }
        });
      } else {
        this.filteredCart.forEach((item) => {
          body.push(item.propertyId);
        });
        this.$refs.printOpt.putOptions({
          apiUrl: apiUrl,
          routeVariables: routeVariables,
          body: body
        });
        this.$bvModal.show("print-options-modal");
      }
    },
    async printIcf() {
      this.$bvModal.hide("icf-modal");
      var apiUrl = `api/Report/Property/ICF/Campus`;
      var routeVariables = [this.campusId];
      this.$refs.printOpt.putOptions({
        apiUrl: apiUrl,
        routeVariables: routeVariables
      });
      this.$bvModal.show("print-options-modal");
    },
    async printIcfEmployee(type = 1) {
      this.submitted = true;
      if (
        this.employeeIdNumberPrint == "" ||
        this.employeeIdNumberPrint == null
      ) {
        return;
      } else {
        this.$bvModal.hide("icf-modal");
        var employeeIdNumber = this.employeeIdNumberPrint;
        var apiUrl = ``;
        if(this.getByPrint == 2 || type == 1){
          apiUrl = `api/Report/Property/ICF`;
        }else if(this.getByPrint == 5 || type == 2){
          apiUrl = `api/Report/Property/ICF/HighValue`;
        }else if(this.getByPrint == 6 || type == 3){
          apiUrl = `api/Report/Property/ICF/LowValue`;
        }
        var routeVariables = [employeeIdNumber];
        this.$refs.printOpt.putOptions({
          apiUrl: apiUrl,
          routeVariables: routeVariables
        });
        this.$bvModal.show("print-options-modal");
        this.submitted = false;
      }
    },
    async printIcfEmployeeAll() {
      this.submitted = true;
      if (
        this.employeeIdNumberPrint == "" ||
        this.employeeIdNumberPrint == null
      ) {
        return;
      } else {
        this.$bvModal.hide("icf-modal");
        var employeeIdNumber = this.employeeIdNumberPrint;
        var apiUrl = `api/Report/Property/ICF/All`;
        var routeVariables = [employeeIdNumber];
        this.$refs.printOpt.putOptions({
          apiUrl: apiUrl,
          routeVariables: routeVariables
        });
        this.$bvModal.show("print-options-modal");
        this.submitted = false;
      }
    },
    async printIcfLocation() {
      this.submitted = true;
      if (this.locationIdPrint == "" || this.locationIdPrint == null) {
        return;
      } else {
        this.$bvModal.hide("icf-modal");
        var apiUrl = `api/Report/Property/ICF/Location`;
        var routeVariables = [this.campusId];
        var body = [];
        body.push(this.locationIdPrint);
        this.$refs.printOpt.putOptions({
          apiUrl: apiUrl,
          routeVariables: routeVariables,
          body: body
        });
        this.$bvModal.show("print-options-modal");
        this.submitted = false;
      }
    },
    async printPpeEmployee(type = 'rpcppe') {
      this.submitted = true;
      if (
        this.employeeIdNumberPrint == "" ||
        this.employeeIdNumberPrint == null
      ) {
        return;
      } else {
        this.$bvModal.hide("ppe-modal");
        var employeeIdNumber = this.employeeIdNumberPrint;
        var apiUrl = type === 'rpcppe' ? `api/Report/Property/Inventory/PPE` : 'api/Report/Property/Inventory/RPCSP/Employee';
        var routeVariables = [employeeIdNumber];
        this.$refs.printOpt.putOptions({
          apiUrl: apiUrl,
          routeVariables: routeVariables
        });
        this.$bvModal.show("print-options-modal");
        this.submitted = false;
      }
    },
    printPpeStickers() {
      var employeeIdNumber = this.employeeIdNumberPrint;
      var apiUrl = `api/Report/Property/Property/Sticker/PPE/Employee`;
      var routeVariables = [];
      this.$refs.printOpt.putOptions({
        apiUrl: apiUrl,
        routeVariables: routeVariables,
        body: {
          body: employeeIdNumber
        }
      });
      this.$bvModal.show("print-options-modal");
    },
    getIcf() {
      this.submitted = false;
      this.employeeNamePrint = "";
      this.employeeIdPrint = "";
      this.$bvModal.show("icf-modal");
    },
    getPpe(type = 'rpcppe') {
      this.submitted = false;
      this.employeeNamePrint = "";
      this.employeeIdPrint = "";
      this.rpType = type;
      this.$bvModal.show("ppe-modal");
    },
    getEmployeeWithProperties() {
      this.$refs.printOpt.putOptions({
        apiUrl: `api/Report/Property/Employee/All/Campus`,
        routeVariables: [this.$store.state.data.selectedCampus.id],
      });
      this.$bvModal.show("print-options-modal");
    },
    getEmployeeWithSemiExProperties(){
      this.$refs.printOpt.putOptions({
        apiUrl: `api/Report/Property/Employee/CSE/All/Campus`,
        routeVariables: [this.$store.state.data.selectedCampus.id],
      });
      this.$bvModal.show("print-options-modal");
    },
    onUpdateItem(props) {
      props.visible = false;
      props.itemVisible = false;
      props.assignmentHistory = [];
      props.assignVisible = false;
      props.assignLoading = false;
      props.inventory = [];
      props.inventoryVisible = false;
      props.inventoryLoading = false;
      props.inspectionVisible = false;
      props.attachmentVisible = false;
      props.attachmentLoading = false;
      props.addDocu = false;
      props.fileSearch = "";
      props.propertyInspections.forEach((inspect) => {
        inspect.inspectionFiles = [];
        inspect.attachmentLoading = false;
      });
      if (this.bySearch) {
        this.tableData.splice(this.propertyindex, 1, props);
      } else {
        this.tableData[this.poIndex].details.splice(
          this.propertyindex,
          1,
          props
        );
      }
    },
    updateItem(props, po) {
      if (this.bySearch) {
        this.propertyindex = this.tableData.findIndex(
          (item) => item.id == props.id
        );
      } else {
        this.poIndex = this.tableData.findIndex(
          (item) => item.poNumber == po.poNumber
        );
        this.propertyindex = this.tableData[this.poIndex].details.findIndex(
          (item) => item.id == props.id
        );
      }
      this.$refs.propertyupdate.updateProperty(props.id);
    },
    onAddInventory() {
      this.submitted = true;
      if (this.inventorySelected) {
        var inventoryId = this.inventorySelected.id;
        var propertyIds = [];
        this.filteredCart.forEach((item) => {
          propertyIds.push(item.propertyId);
        });
        this.$swal({
          title: "Are you sure?",
          text: `${propertyIds.length} ${propertyIds.length > 1 ? "properties" : "property"
            } selected.`,
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#5c636a",
          confirmButtonText: "Yes, add to inventory!",
          allowOutsideClick: false
        }).then((result) => {
          if (result.isConfirmed) {
            this.$store
              .dispatch("propertyinventory/CreatePropertyInventoryItem", {
                propertyIds,
                inventoryId
              })
              .then((res) => {
                this.inventorySelected = null;
                this.submitted = false;
                this.$bvModal.hide("modal-inventory");
                this.showToast("Successfully added to inventory", "success");
              })
              .catch((err) => {
                this.showToast("Cannot be added to inventory!", "error");
              });
          }
        });
      } else return;
    },
    addInventory() {
      this.inventorySelected = null;
      this.inventoryTitle = "";
      this.submitted = false;
      this.modalTitle = "Add to Inventory";
      this.$bvModal.show("modal-inventory");
    },
    onTransferCampus() {
      this.submitted = true;
      if (this.campusSelected) {
        var campusId = this.campusSelected.id;
        var propertyIds = [];
        this.filteredCart.forEach((item) => {
          propertyIds.push(item.propertyId);
        });
        this.$swal({
          title: "Are you sure?",
          text: `${propertyIds.length} ${propertyIds.length > 1 ? "properties" : "property"
            } selected.`,
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#5c636a",
          confirmButtonText: "Yes, transfer items!",
          allowOutsideClick: false
        }).then((result) => {
          if (result.isConfirmed) {
            this.$store
              .dispatch("property/PropertyTransfer", { propertyIds, campusId })
              .then((res) => {
                this.campusSelected = null;
                this.campus = "";
                this.getProperties();
                this.submitted = false;
                this.$bvModal.hide("modal-transfer-campus");
                this.showToast("Successfully transferred", "success");
              })
              .catch((err) => {
                this.showToast("Cannot be transferred!", "error");
              });
          }
        });
      } else return;
    },
    transferCampus() {
      this.campus = "";
      this.campusSelected = null;
      this.submitted = false;
      this.modalTitle = `Transfer ${this.GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}`;
      this.$bvModal.show("modal-transfer-campus");
    },
    onChangeMultiple() {
      this.submitted = true;
      if (this.multipleUpdateType == "category") {
        if (
          this.itemCategoryIdChange == null ||
          this.itemCategoryIdChange == ""
        )
          return;
        this.onChangeCategory();
      } else if (this.multipleUpdateType == "dateAcquired") {
        if (this.dateAcquiredChange == null || this.dateAcquiredChange == "")
          return;
        this.onChangeDateAcquired();
      } else if (this.multipleUpdateType == "dateAssigned") {
        if (this.dateAssignedChange == null || this.dateAssignedChange == "")
          return;
        this.onChangeDateAssigned();
      } else if (this.multipleUpdateType == "cost") {
        if (this.unitCostChange == null || this.unitCostChange == "") return;
        this.onChangeUnitCost();
      } else if (this.multipleUpdateType == "location") {
        if (this.locationIdChange == null || this.locationIdChange == "")
          return;
        this.onChangeLocation();
      } else if (this.multipleUpdateType == "condition") {
        if (this.conditionChange == null || this.conditionChange == "") return;
        this.onChangeCondition();
      }
      this.submitted = false;
    },
    onChangeCategory() {
      var itemCategoryId = this.itemCategoryIdChange;
      var propertyIds = [];
      this.filteredCart.forEach((item) => {
        propertyIds.push(item.propertyId);
      });
      this.$swal({
        title: "Are you sure?",
        text: `${propertyIds.length} ${propertyIds.length > 1 ? "properties" : "property"
          } selected.`,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, change it!",
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("property/ChangeCategory", {
              propertyIds,
              itemCategoryId
            })
            .then((res) => {
              this.itemCategoryIdChange = null;
              this.itemCategoryChange = "";
              this.getProperties();
              this.$bvModal.hide("modal-multiple-update");
              this.showToast("Successfully changed category", "success");
            })
            .catch((err) => {
              this.showToast("Cannot change category!", "error");
            });
        }
      });
    },
    onChangeDateAcquired() {
      var dateAcquired = this.getDate(this.dateAcquiredChange);
      var propertyIds = [];
      this.filteredCart.forEach((item) => {
        propertyIds.push(item.propertyId);
      });
      this.$swal({
        title: "Are you sure?",
        text: `${propertyIds.length} ${propertyIds.length > 1 ? "properties" : "property"
          } selected.`,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, change it!",
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("property/updateDateAcquired", {
              propertyIds,
              dateAcquired
            })
            .then((res) => {
              this.dateAcquiredChange = null;
              this.getProperties();
              this.$bvModal.hide("modal-multiple-update");
              this.showToast("Successfully changed date acquired", "success");
            })
            .catch((err) => {
              this.showToast("Cannot change date acquired!", "error");
            });
        }
      });
    },
    onChangeDateAssigned() {
      var assignmentDate = this.getDate(this.dateAssignedChange);
      var propertyAssignmentIds = [];
      this.filteredCart.forEach((item) => {
        if (item.assignmentId) {
          propertyAssignmentIds.push(item.assignmentId);
        }
      });
      this.$swal({
        title: "Are you sure?",
        text: `${propertyAssignmentIds.length} ${propertyAssignmentIds.length > 1 ? "properties" : "property"
          } selected.`,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, change it!",
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("propertyassignment/updateDateAssigned", {
              propertyAssignmentIds,
              assignmentDate
            })
            .then((res) => {
              this.dateAssignedChange = null;
              this.getProperties();
              this.$bvModal.hide("modal-multiple-update");
              this.showToast("Successfully changed date assigned", "success");
            })
            .catch((err) => {
              this.showToast("Cannot change date assigned!", "error");
            });
        }
      });
    },
    onChangeUnitCost() {
      var unitCost = this.getExactAmt(this.unitCostChange);
      var propertyIds = [];
      this.filteredCart.forEach((item) => {
        propertyIds.push(item.propertyId);
      });
      this.$swal({
        title: "Are you sure?",
        text: `${propertyIds.length} ${propertyIds.length > 1 ? "properties" : "property"
          } selected.`,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, change it!",
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("property/updateUnitCost", { propertyIds, unitCost })
            .then((res) => {
              this.filteredCart.forEach((item) => {
                item.amount = unitCost;
              });
              this.unitCostChange = "";
              this.getProperties();
              this.$bvModal.hide("modal-multiple-update");
              this.showToast("Successfully changed unit cost", "success");
            })
            .catch((err) => {
              this.showToast("Cannot change unit cost!", "error");
            });
        }
      });
    },
    onChangeLocation() {
      var propertyLocationId = this.locationIdChange;
      var propertyAssignmentIds = [];
      this.filteredCart.forEach((item) => {
        if (item.assignmentId) {
          propertyAssignmentIds.push(item.assignmentId);
        }
      });
      this.$swal({
        title: "Are you sure?",
        text: `${propertyAssignmentIds.length} ${propertyAssignmentIds.length > 1 ? "properties" : "property"
          } selected.`,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, change it!",
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("propertyassignment/updateLocation", {
              propertyAssignmentIds,
              propertyLocationId
            })
            .then((res) => {
              this.locationIdChange = null;
              this.locationChange = "";
              this.getProperties();
              this.$bvModal.hide("modal-multiple-update");
              this.showToast("Successfully changed location", "success");
            })
            .catch((err) => {
              this.showToast("Cannot change location!", "error");
            });
        }
      });
    },
    onChangeCondition() {
      var condition = this.conditionChange;
      var propertyIds = [];
      this.filteredCart.forEach((item) => {
        propertyIds.push(item.propertyId);
      });
      this.$swal({
        title: "Are you sure?",
        text: `${propertyIds.length} ${propertyIds.length > 1 ? "properties" : "property"
          } selected.`,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, change it!",
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("property/updateCondition", {
              propertyIds,
              condition
            })
            .then((res) => {
              this.conditionChange = "";
              this.getProperties();
              this.$bvModal.hide("modal-multiple-update");
              this.showToast("Successfully changed condition", "success");
            })
            .catch((err) => {
              this.showToast("Cannot change condition!", "error");
            });
        }
      });
    },
    changeItemCategory() {
      this.multipleUpdateType = "category";
      this.itemCategoryChange = "";
      this.itemCategoryIdChange = null;
      this.submitted = false;
      this.modalTitle = "Change Item Category";
      this.$bvModal.show("modal-multiple-update");
    },
    changeDateAcquired() {
      this.multipleUpdateType = "dateAcquired";
      this.dateAcquiredChange = null;
      this.submitted = false;
      this.modalTitle = "Change Date Acquired";
      this.$bvModal.show("modal-multiple-update");
    },
    changeDateAssigned() {
      this.multipleUpdateType = "dateAssigned";
      this.dateAssignedChange = null;
      this.submitted = false;
      this.modalTitle = "Change Date Assigned";
      this.$bvModal.show("modal-multiple-update");
    },
    changeUnitCost() {
      this.multipleUpdateType = "cost";
      this.unitCostChange = "";
      this.submitted = false;
      this.modalTitle = "Change Unit Cost";
      this.$bvModal.show("modal-multiple-update");
    },
    changeLocation() {
      this.multipleUpdateType = "location";
      this.locationIdChange = null;
      this.locationChange = "";
      this.submitted = false;
      this.modalTitle = "Change Location";
      this.$bvModal.show("modal-multiple-update");
    },
    changeCondition() {
      this.multipleUpdateType = "condition";
      this.conditionChange = "";
      this.submitted = false;
      this.modalTitle = "Change Condition";
      this.$bvModal.show("modal-multiple-update");
    },
    checkTransfer() {
      var error = 0;
      if (this.transferForm.transferToEmployeeId == null) error++;
      this.transferForm.propertyTransferItems.forEach((item) => {
        if (item.propertyLocationId == null) error++;
      });
      if (error > 0) return true;
      else return false;
    },
    onTransferMultipleItems() {
      this.submitted = true;
      if (this.checkTransfer()) return;
      else {
        this.$swal({
          title: "Are you sure?",
          text: `${this.transferForm.propertyTransferItems.length} ${this.transferForm.propertyTransferItems.length > 1
              ? "properties"
              : "property"
            } selected.`,
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#5c636a",
          confirmButtonText: "Yes, transfer it!",
          allowOutsideClick: false
        }).then((result) => {
          if (result.isConfirmed) {
            this.$store
              .dispatch(
                "propertytransfer/CreatePropertyTransfer",
                this.transferForm
              )
              .then(() => {
                this.filteredCart.forEach((item) => {
                  item.currentAssignment = null;
                });
                this.getProperties();
                this.showToast("Successfully transfered", "success");
                this.$bvModal.hide("assignmenthistory-modal-transfer");
              })
              .catch((err) => {
                this.showToast("Cannot be transfered!", "error");
              });
          }
        });
      }
      this.submitted = false;
    },
    transferMultipleItems() {
      let error = 0;
      let employeeIdNumber = null;

      // this.filteredCart.forEach((item) => {
      //   if (item.currentAssignment) {
      //     if (employeeIdNumber) {
      //       if (employeeIdNumber != item.currentAssignment.employeeIdNumber) {
      //         error++;
      //       }
      //     } else {
      //       employeeIdNumber = item.currentAssignment.employeeIdNumber;
      //     }
      //   } else {
      //     error++;
      //   }
      // });

      // if (error > 0) {
      //   this.showToast(
      //     "Ensure that all items selected are assigned to the same employee.",
      //     "warning"
      //   );
      // } else {
        this.onReset();
        this.filteredCart.forEach((item) => {
          this.transferForm.propertyTransferItems.push({
            propertyId: item.propertyId,
            name: item.propertyName,
            propertyNumber: item.propertyNumber,
            propertyAssignmentId: item.assignmentId || 0,
            propertyLocationId: item.locationId || 0,
            location: item.location || "",
            toggleSelected: false
          });
        });
        this.transferForm.fromEmployeeId = this.filteredCart[0].employeeIdNumber || "";
        this.transferForm.assignmentType = "Reassignment";
        this.modalTitle = "Transfer Item";
        this.$bvModal.show("assignmenthistory-modal-transfer");
      // }
    },
    onReturnMultipleItems() {
      this.submitted = true;
      if (
        this.returnForm.dateReturned == "" ||
        this.returnForm.dateReturned == null
      )
        return;
      else {
        var properties = [];
        this.filteredCart.forEach((item) => {
          if (item.assignmentId) {
            var id = item.assignmentId;
            var returnNotes = this.returnForm.returnNotes;
            var dateReturned = this.getDate(this.returnForm.dateReturned);
            properties.push({ id, returnNotes, dateReturned });
          }
        });
        this.$swal({
          title: "Are you sure?",
          text: `${properties.length} ${properties.length > 1 ? "properties" : "property"
            } selected.`,
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#5c636a",
          confirmButtonText: "Yes, return items!",
          allowOutsideClick: false
        }).then((result) => {
          if (result.isConfirmed) {
            this.$store
              .dispatch(
                "propertyassignment/ReturnMultiplePropertyAssignment",
                properties
              )
              .then((res) => {
                this.filteredCart.forEach((item) => {
                  item.currentAssignment = null;
                });
                this.getProperties();
                this.$bvModal.hide("modal-standard");
                this.showToast("Successfully returned", "success");
              })
              .catch((err) => {
                this.showToast("Cannot be returned!", "error");
              });
          }
        });
      }
      this.submitted = false;
    },
    returnMultipleItems() {
      this.onReset();
      this.returnForm.id = null;
      this.returnForm.dateReturned = new Date();
      this.returnForm.returnNotes = "";
      this.modalTitle = "Return Items";
      this.$bvModal.show("modal-standard");
    },
    showEmployee(props) {
      if (props) {
        this.accountableEmployee = null;
        this.accountableEmployee = cloneDeep(props);
        this.employeeIdNumberPrint = this.accountableEmployee.idNo;
        this.modalTitle = "Accountable Officer Detail";
        this.$bvModal.show("modal-accountableEmployee");
      }
    },
    onReset() {
      this.formCancel = {
        id: null,
        returnNotes: "",
        dateReturned: ""
      };
      this.transferForm = {
        propertyTransferItems: [],
        campusId: this.campusId,
        type: "",
        reason: "",
        assignmentNote: "",
        fromEmployeeId: null,
        transferToEmployeeId: null,
        employeeName: "",
        remarks: "",
        location: "",
        locationId: 0,
        toggleAll: false
      };
      this.returnForm = {
        id: null,
        returnNotes: "",
        dateReturned: ""
      };
      this.submitted = false;
      this.employeeName = "";
      this.fundCluster = "";
      this.location = "";
      this.poIndex = -1;
      this.propertyIndex = -1;
      this.itemIndex = -1;
    },
    getFundCluster(type) {
      this.$refs.fundcluster.getData();
      this.$bvModal.show("fund-cluster-modal");
      this.getClusterType = type;
    },
    dropFundCluster(data) {
      if (this.getClusterType == "get") {
        this.fundClusterId = data.id;
        this.fundClusterGet = data.cluster;
        this.getBySearch();
      } else if (this.getClusterType == "create-modal") {
        this.$refs.propertyupdate.dropFundCluster(data);
      }
    },
    removeFundCluster(type) {
      this.fundClusterId = 0;
      this.fundClusterGet = "";
    },
    getItemCategory(type) {
      this.$refs.itemcategory.filterPropertyCategory();
      this.$bvModal.show("item-category-modal");
      this.getCategoryType = type;
    },
    dropItemCat(data) {
      if (this.getCategoryType == "change") {
        this.itemCategoryIdChange = data.id;
        this.itemCategoryChange = data.name;
      } else if (this.getCategoryType == "create-modal") {
        this.$refs.propertyupdate.dropItemCat(data);
      } else {
        this.itemCategoryId = data.id;
        this.itemCategoryGet = data.name;
        this.getBySearch();
      }
    },
    removeItemCat(type) {
      if (type == "change") {
        this.itemCategoryIdChange = 0;
        this.itemCategoryChange = "";
      } else {
        this.itemCategoryId = 0;
        this.itemCategoryGet = "";
      }
    },
    getSupplier() {
      this.$bvModal.show("supplier-modal");
    },
    dropSupplier(data) {
      this.$refs.propertyupdate.dropSupplier(data);
    },
    getUnit() {
      this.$refs.unit.getData();
      this.$bvModal.show("unit-modal");
    },
    dropUnit(data) {
      this.$refs.propertyupdate.dropUnit(data);
    },
    getEmployee(type) {
      this.$refs.employee.resetData();
      this.$bvModal.show("externalEmployee-modal");
      this.getEmployeeType = type;
    },
    dropEmployee(data) {
      var firstname = data.firstName;
      var lastname = data.lastName;
      if (this.getEmployeeType == "get") {
        this.employeeId = data.idNo;
        this.employeeNameGet = firstname.concat(" ", lastname);
        this.getBySearch();
      } else if (this.getEmployeeType == "print") {
        this.employeeIdNumberPrint = data.idNo;
        this.employeeNamePrint = firstname.concat(" ", lastname);
      } else if (this.getEmployeeType == "transfer") {
        this.transferForm.transferToEmployeeId = data.idNo;
        this.transferForm.employeeName = firstname.concat(" ", lastname);
      } else {
        this.assignmentHistoryEmployeeData = data;
      }
    },
    removeEmployee(type) {
      if (type == "get") {
        this.employeeId = "";
        this.employeeNameGet = "";
      } else if (type == "print") {
        this.employeeIdNumberPrint = "";
        this.employeeNamePrint = "";
      }
    },
    getLocation(type, item) {
      this.$refs.location.getData(this.campusId);
      this.$bvModal.show("location-modal");
      this.getLocationType = type;
      this.getLocationItem = item ? item : null;
    },
    dropLocation(data) {
      if (this.getLocationType == "get") {
        this.locationIdSelected = data.location.id;
        this.locationGet = data.location.location;
        this.getBySearch();
      } else if (this.getLocationType == "change") {
        this.locationIdChange = data.location.id;
        this.locationChange = data.location.location;
      } else if (this.getLocationType == "print") {
        this.locationIdPrint = data.location.id;
        this.locationNamePrint = data.location.location;
      } else if (this.getLocationType == "transfer") {
        if (this.getLocationItem) {
          this.getLocationItem.propertyLocationId = data.location.id;
          this.getLocationItem.location = data.location.location;
        } else {
          this.transferForm.location = data.location.location;
          this.transferForm.locationId = data.location.id;
          this.transferForm.propertyTransferItems.forEach((item) => {
            item.propertyLocationId = data.location.id;
            item.location = data.location.location;
          });
        }
      } else {
        this.assignmentHistoryLocationData = data;
      }
    },
    removeLocation(type, item) {
      if (type == "get") {
        this.locationIdSelected = 0;
        this.locationGet = "";
      } else if (type == "transfer") {
        this.transferForm.location = null;
        this.transferForm.locationId = "";
        item.propertyLocationId = null;
        item.location = "";
      }
    },
    getCampus() {
      this.$refs.campus.getData();
      this.$bvModal.show("campus-modal");
    },
    dropCampus(data) {
      this.campusSelected = data;
      this.campus = data.campusName;
    },
    getInventory() {
      this.$refs.inventory.getData();
      this.$bvModal.show("inventory-modal");
    },
    dropInventory(data) {
      this.inventorySelected = data;
      this.inventoryTitle = data.title;
    },
    showDtls(row) {
      if (row.item.visible) {
        row.item.visible = !row.item.visible;
        setTimeout(() => {
          row.toggleDetails();
        }, 600);
      } else {
        row.toggleDetails();
        setTimeout(() => {
          row.item.visible = !row.item.visible;
        }, 50);
      }
    },
    checkPropertyType(row) {
      var PAR = 0;
      var ICS = 0;
      row.forEach((item) => {
        if (item.amount >= 50000) PAR++;
        else ICS++;
      });
      if (PAR == 0 && ICS == 0) return 0;
      else if (PAR > 0 && ICS == 0) return 1;
      else if (PAR == 0 && ICS > 0) return 2;
      else if (PAR > 0 && ICS > 0) return 3;
    },
    async showCart() {
      this.$bvModal.show("modal-cart");
      if(this.newItemAdded){
        this.selectedProperties = [];
        await this.getMyCart();
        this.newItemAdded = false;
      }
    },
    addAllToCart(props, currentPage, perPage) {
      var data = cloneDeep(props);
      var total = currentPage * perPage;
      var currentData = data.reverse().slice(total - perPage, total);
      if (currentPage > 1 && currentData.length == 0) {
        total = (currentPage - 1) * perPage;
        currentData = data.slice(total - perPage, total);
      }
      var count = 0;
      currentData.forEach((item) => {
        if (this.checkCart(item)) {
          this.selectedProperties.push(item);
          count = count + 1;
        }
      });
      this.newItemAdded = true;
      this.addCartProperties(currentData.map(item => ({id: item.id})));
      // this.setCartProperties();
      if (count > 0) {
        this.showToast(
          `All visible properties in page ${currentPage} are added to cart.`,
          "info"
        );
      } else {
        this.showToast(
          `All visible properties in page ${currentPage} have already been added to cart.`,
          "warning"
        );
      }
    },
    addToCart(row) {
      this.newItemAdded = true;
      this.selectedProperties.push(row);
      this.addCartProperties([{id: row.id}]);
    },
    async addCartProperties(ids) {
      try{
        const { data:response } = await this.$store.dispatch("propertycart/AddToCart", ids);
        if(response.error){
          this.showToast(response.errorMessage, "error");
          return;
        }
      }catch(err){
        this.showToast("Error saving to cart!", "error");
        return;
      }
    },
    addAssignedToCart() {
      var count = 0;
      this.filtered.forEach((item) => {
        if (this.checkCart(item)) {
          this.selectedProperties.push(item);
          count = count + 1;
        }
      });
      this.setCartProperties();
      if (count > 0) {
        if (this.filter.trim() == "") {
          this.showToast(
            `All properties assigned to ${this.employeeData.firstName
              .charAt(0)
              .toUpperCase() + this.employeeData.firstName.slice(1)} ${this.employeeData.middleName
              ? `${this.employeeData.middleName.charAt(0).toUpperCase()}.`
              : ""
            } ${this.employeeData.lastName.charAt(0).toUpperCase() +
            this.employeeData.lastName.slice(1)} are added to cart.`,
            "info"
          );
        } else {
          this.showToast("Searched properties are added to cart", "info");
        }
      } else {
        if (this.filter.trim() == "") {
          this.showToast(
            `All properties assigned to ${this.employeeData.firstName
              .charAt(0)
              .toUpperCase() + this.employeeData.firstName.slice(1)} ${this.employeeData.middleName
              ? `${this.employeeData.middleName.charAt(0).toUpperCase()}.`
              : ""
            } ${this.employeeData.lastName.charAt(0).toUpperCase() +
            this.employeeData.lastName.slice(
              1
            )} has already been added to cart.`,
            "warning"
          );
        } else {
          this.showToast(
            "Searched properties has already been added to cart",
            "warning"
          );
        }
      }
    },
    removeAllFromCart(props, currentPage, perPage) {
      var data = cloneDeep(props);
      var total = currentPage * perPage;
      var currentData = data.reverse().slice(total - perPage, total);
      if (currentPage > 1 && currentData.length == 0) {
        total = (currentPage - 1) * perPage;
        currentData = data.slice(total - perPage, total);
      }
      var count = 0;
      currentData.forEach((item) => {
        var index = this.selectedProperties.findIndex((x) => x.id == item.id);
        if (index != -1) {
          this.selectedProperties.splice(index, 1);
          count = count + 1;
        }
      });
      this.setCartProperties();
      if (count > 0) {
        this.showToast(
          `All visible properties in page ${currentPage} are removed from cart.`,
          "error"
        );
      } else {
        this.showToast(
          `All visible properties in page ${currentPage} are not yet added in cart.`,
          "warning"
        );
      }
    },
    async removeFromMyCart(row) {
      try{
        const { data:response } = await this.$store.dispatch("propertycart/RemoveFromCart", row.id);
        if(response.error){
          this.showToast(response.errorMessage, "error");
          return;
        }
      }catch(err){
        this.showToast("Error removing from cart!", "error");
        return;
      }
    },
    removeFromCart(row) {
      var index = this.selectedProperties.findIndex((x) => x.id == row.id);
      this.selectedProperties.splice(index, 1);
      this.removeFromMyCart(row);
      if (this.selectedProperties.length == 0) this.$bvModal.hide("modal-cart");
    },
    removeAssignedFromCart() {
      var count = 0;
      this.filtered.forEach((item) => {
        var index = this.selectedProperties.findIndex((x) => x.id == item.id);
        if (index != -1) {
          this.selectedProperties.splice(index, 1);
          count = count + 1;
        }
      });
      this.setCartProperties();
      if (count > 0) {
        if (this.filter.trim() == "") {
          this.showToast(
            `All properties assigned to ${this.employeeData.firstName
              .charAt(0)
              .toUpperCase() + this.employeeData.firstName.slice(1)} ${this.employeeData.middleName
              ? `${this.employeeData.middleName.charAt(0).toUpperCase()}.`
              : ""
            } ${this.employeeData.lastName.charAt(0).toUpperCase() +
            this.employeeData.lastName.slice(1)} are removed from cart.`,
            "info"
          );
        } else {
          this.showToast("Searched properties are removed from cart", "info");
        }
      } else {
        if (this.filter.trim() == "") {
          this.showToast(
            `Properties assigned to ${this.employeeData.firstName
              .charAt(0)
              .toUpperCase() + this.employeeData.firstName.slice(1)} ${this.employeeData.middleName
              ? `${this.employeeData.middleName.charAt(0).toUpperCase()}.`
              : ""
            } ${this.employeeData.lastName.charAt(0).toUpperCase() +
            this.employeeData.lastName.slice(1)} has not yet been to cart.`,
            "warning"
          );
        } else {
          this.showToast(
            "Searched properties has not yet been added to cart",
            "warning"
          );
        }
      }
    },
    setCartProperties() {
      localStorage.setItem("selectedProperties", JSON.stringify(this.selectedProperties));
    },
    async clearAllCart() {
      try{
        const { data:response } = await this.$store.dispatch("propertycart/ClearCart");
        if(response.error){
          this.showToast(response.errorMessage, "error");
          return;
        }
      }catch(err){
        this.showToast("Error clearing cart!", "error");
        return;
      }
    },
    clearCart() {
      this.selectedProperties = [];
      this.clearAllCart();
      this.$bvModal.hide("modal-cart");
      this.showToast("Cart Cleared!", "error");
    },
    checkCart(row) {
      var index = this.selectedProperties.findIndex((x) => x.id == row.id);
      if (index == -1) return true;
      else return false;
    },
    propertyNumberWidth(number) {
      if (number < 100) return "min-width: 35px";
      else if (number < 1000) return "min-width: 50px";
      else if (number < 10000) return "min-width: 60px";
      else return "min-width: 75px";
    },
  }
};
</script>

<template>
  <Layout @changeCampus="changeCampus">
    <PageHeader :title="title" :items="items" />
    <!-- View Employee Info -->
    <b-modal id="modal-accountableEmployee" :title="modalTitle" size="md" title-class="font-18" hide-footer
      no-close-on-backdrop>
      <div v-if="accountableEmployee && accountableEmployee.firstName">
        <div class="d-flex align-items-center">
          <div class="avatar-sm me-2">
            <span class="avatar-title rounded-circle bg-soft bg-primary text-primary font-size-16">{{
              accountableEmployee.firstName.charAt(0).toUpperCase()
              }}{{ accountableEmployee.lastName.charAt(0).toUpperCase() }}</span>
          </div>
          <div>
            <div class="mt-1">
              <h5 class="mb-0">
                {{
                  accountableEmployee.lastName.charAt(0).toUpperCase() +
                  accountableEmployee.lastName.slice(1)
                }},
                {{
                  accountableEmployee.firstName.charAt(0).toUpperCase() +
                  accountableEmployee.firstName.slice(1)
                }}
                {{
                  accountableEmployee.middleName
                    ? `${accountableEmployee.middleName
                      .charAt(0)
                      .toUpperCase()}.`
                    : ""
                }}
              </h5>
            </div>
            <div>{{ accountableEmployee.idNo }}</div>
          </div>
        </div>
        <hr class="my-3" />
        <div class="ps-3 pe-3">
          <b-row class="mb-2">
            <b-col class="p-0" sm="2">
              <b>Office</b>
            </b-col>
            <b-col :class="{ 'text-white': accountableEmployee.office }">{{
              accountableEmployee.office
                ? accountableEmployee.office
                : "No record"
            }}</b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col class="p-0" sm="2">
              <b>Position</b>
            </b-col>
            <b-col :class="{ 'text-white': accountableEmployee.position }">{{
              accountableEmployee.position
                ? accountableEmployee.position
                : "No record"
            }}</b-col>
          </b-row>
        </div>
        <hr class="my-3" />
        <div class="d-flex float-end">
          <b-dropdown id="dropdown-left" right variant="link" toggle-class="text-decoration-none p-0"
            menu-class="dropdown-menu-left" no-caret>
            <template #button-content>
              <button type="button" class="btn btn-sm btn-purple d-flex align-items-center justify-content-center me-1">
                <i class="bx bx-printer fs-6 me-1"></i>Print Documents
              </button>
            </template>
            <b-dropdown-item @click="printParEmployee()"><i
                class="bx bx-printer font-size-18 text-purple me-1"></i>Print
              PAR</b-dropdown-item>
            <b-dropdown-item @click="printIcsEmployee()"><i
                class="bx bx-printer font-size-18 text-purple me-1"></i>Print
              ICS</b-dropdown-item>
            <b-dropdown-item @click="printIcfEmployee(1)"><i
                class="bx bx-printer font-size-18 text-purple me-1"></i>Print
              ICF (PPE)</b-dropdown-item>
            <b-dropdown-item @click="printIcfEmployee(2)"><i
              class="bx bx-printer font-size-18 text-purple me-1"></i>Print
              ICF (High Value)</b-dropdown-item>
            <b-dropdown-item @click="printIcfEmployee(3)"><i
              class="bx bx-printer font-size-18 text-purple me-1"></i>Print
              ICF (Low Value)</b-dropdown-item>
            <b-dropdown-item @click="printIcfEmployeeAll()"><i
                class="bx bx-printer font-size-18 text-purple me-1"></i>Print
              ICF (All)</b-dropdown-item>
            <b-dropdown-item @click="printPpeEmployee('rpcppe')"><i
                class="bx bx-printer font-size-18 text-purple me-1"></i>Print
              RPCPPE</b-dropdown-item>
            <b-dropdown-item @click="printPpeEmployee('rpcsp')"><i
                class="bx bx-printer font-size-18 text-purple me-1"></i>Print
              RPCSP</b-dropdown-item>
            <b-dropdown-item @click="printPpeStickers()"><i
                class="bx bx-printer font-size-18 text-purple me-1"></i>Print
              PPE Stickers</b-dropdown-item>
          </b-dropdown>
        </div>
      </div>
    </b-modal>
    <!-- Transfer Property -->
    <b-modal id="assignmenthistory-modal-transfer" :title="modalTitle" size="lg" title-class="font-18" hide-footer
      no-close-on-backdrop>
      <form @submit.prevent="onTransferMultipleItems" class="needs-validation" ref="fcForm">
        <div class="mb-3">
          <label for="employee">Employee</label>
          <b-input-group>
            <template #append>
              <b-button @click="getEmployee('transfer')" variant="outline-info"><i
                  class="mdi mdi-clipboard-text-search-outline"></i></b-button>
            </template>
            <input autocomplete="off" type="text" disabled placeholder="Search Employee..." class="form-control" :class="{
              'is-invalid':
                submitted &&
                (transferForm.transferToEmployeeId == null ||
                  transferForm.transferToEmployeeId == '')
            }" v-model="transferForm.employeeName" />
          </b-input-group>
          <div v-if="
            submitted &&
            (transferForm.transferToEmployeeId == null ||
              transferForm.transferToEmployeeId == '')
          " class="invalid-feedback">
            <span>This value is required.</span>
          </div>
        </div>
        <!-- <div class="mb-3">
          <label for="assignmentType">Assignment Type </label>
          <b-form-select class="form-select" :class="{
            'is-invalid':
              submitted &&
              (transferForm.assignmentType == null ||
                transferForm.assignmentType == ''),
          }" v-model="transferForm.assignmentType">
            <b-form-select-option value="" disabled>Select Type...</b-form-select-option>
            <b-form-select-option value="New">New</b-form-select-option>
            <b-form-select-option value="Donation">Donation</b-form-select-option>
            <b-form-select-option value="Reassignment">Reassignment</b-form-select-option>
            <b-form-select-option value="Relocate">Relocate</b-form-select-option>
            <b-form-select-option value="Others">Others</b-form-select-option>
          </b-form-select>
          <div v-if="
            submitted &&
            (transferForm.assignmentType == null ||
              transferForm.assignmentType == '')
          " class="invalid-feedback">
            <span>This value is required.</span>
          </div>
        </div> -->
        <div class="mb-3">
          <label for="reason">Reason </label>
          <textarea id="reason" rows="2" v-model="transferForm.reason" placeholder="Enter Reason..."
            class="form-control" autocomplete="off"></textarea>
        </div>
        <div class="mb-3">
          <label for="assignmentNote">Note </label>
          <textarea id="assignmentNote" rows="2" v-model="transferForm.assignmentNote" placeholder="Enter Note..."
            class="form-control" autocomplete="off"></textarea>
        </div>
        <div class="mb-3">
          <label>Bulk Assign Location</label>
          <b-input-group>
            <template #append>
              <b-button @click="getLocation('transfer')" variant="outline-info"><i
                  class="mdi mdi-clipboard-text-search-outline"></i></b-button>
            </template>
            <input autocomplete="off" type="text" disabled placeholder="Assign location to all items"
              class="form-control" v-model="transferForm.location" />
          </b-input-group>
        </div>
        <div class="mb-3">
          <hr class="my-2" />
          <div style="max-height: 180px; overflow: auto" class="pe-2">
            <table width="100%">
              <tbody>
                <tr v-for="(item, index) in transferForm.propertyTransferItems" :key="index">
                  <td class="py-2">
                    <div class="d-flex">
                      <div class="me-3">{{ index + 1 }}.</div>
                      <div>
                        <div>{{ item.name }}</div>
                        <small>{{ item.propertyNumber }}</small>
                      </div>
                    </div>
                  </td>
                  <td style="width: 50%" class="py-2">
                    <b-input-group>
                      <template #append>
                        <b-button v-if="item.propertyLocationId == null" @click="getLocation('transfer', item)"
                          variant="outline-info"><i class="mdi mdi-clipboard-text-search-outline"></i></b-button>
                        <b-button v-else @click="removeLocation('transfer', item)" variant="outline-danger"><i
                            class="mdi mdi-close-thick"></i></b-button>
                      </template>
                      <input autocomplete="off" type="text" disabled class="form-control form-control-sm" :class="{
                        'is-invalid':
                          submitted && item.propertyLocationId == null
                      }" v-model="item.location" />
                    </b-input-group>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <hr class="my-2" />
        </div>
        <div class="d-flex float-end mt-2 mb-2">
          <button type="submit" class="btn btn-primary">Transfer</button>
        </div>
      </form>
    </b-modal>
    <!-- Return Property -->
    <b-modal id="modal-standard" :title="modalTitle" size="md" title-class="font-18" hide-footer no-close-on-backdrop>
      <form @submit.prevent="onReturnMultipleItems" class="needs-validation" ref="fcForm">
        <div class="mb-3">
          <label for="dateReturned">Date Returned </label>
          <date-picker v-model="returnForm.dateReturned" :first-day-of-week="1" lang="en"
            placeholder="Enter Date Returned..." :class="{
              'is-invalid':
                submitted &&
                (returnForm.dateReturned == '' ||
                  returnForm.dateReturned == null)
            }"></date-picker>
          <div v-if="
            submitted &&
            (returnForm.dateReturned == '' ||
              returnForm.dateReturned == null)
          " class="invalid-feedback">
            <span>This value is required.</span>
          </div>
        </div>
        <div class="mb-3">
          <label for="returnNotes">Reason for Return: </label>
          <textarea id="returnNotes" rows="4" v-model="returnForm.returnNotes" placeholder="Enter return note..."
            class="form-control" autocomplete="off"></textarea>
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary">Return Property</button>
        </div>
      </form>
    </b-modal>
    <!-- Add to Inventory -->
    <b-modal id="modal-inventory" :title="modalTitle" size="md" title-class="font-18" hide-footer no-close-on-backdrop>
      <label for="inventory">Inventory </label>
      <b-input-group>
        <template #append>
          <b-button @click="getInventory" variant="outline-info" title="Select Inventory"><i
              class="mdi mdi-clipboard-text-search-outline"></i></b-button>
        </template>
        <input autocomplete="off" type="text" placeholder="Select Inventory..." disabled class="form-control" :class="{
          'is-invalid': submitted && inventorySelected == null
        }" v-model="inventoryTitle" />
      </b-input-group>
      <div v-if="submitted && inventorySelected == null" class="invalid-feedback">
        <span>This value is required.</span>
      </div>
      <div class="d-flex justify-content-end">
        <button class="btn btn-primary mt-3" type="button" id="inputGroupFileAddon04" @click="onAddInventory">
          Add
        </button>
      </div>
    </b-modal>
    <!-- Transfer Campus -->
    <b-modal id="modal-transfer-campus" :title="modalTitle" size="md" title-class="font-18" hide-footer
      no-close-on-backdrop>
      <label for="supplier">{{GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}} </label>
      <b-input-group>
        <template #append>
          <b-button @click="getCampus" variant="outline-info" :title="`Select ${GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}`"><i
              class="mdi mdi-clipboard-text-search-outline"></i></b-button>
        </template>
        <input autocomplete="off" type="text" :placeholder="`Select ${GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}...`" disabled class="form-control" :class="{
          'is-invalid': submitted && campus == ''
        }" v-model="campus" />
      </b-input-group>
      <div v-if="submitted && campus == ''" class="invalid-feedback">
        <span>This value is required.</span>
      </div>
      <div class="d-flex justify-content-end">
        <button class="btn btn-primary mt-3" type="button" id="inputGroupFileAddon04" @click="onTransferCampus">
          Transfer
        </button>
      </div>
    </b-modal>
    <!-- Update Multiple -->
    <b-modal id="modal-multiple-update" :title="modalTitle" size="md" title-class="font-18" hide-footer
      no-close-on-backdrop>
      <div v-if="multipleUpdateType == 'category'">
        <label for="itemCategoryId">Item Category </label>
        <b-input-group>
          <template #append>
            <b-button @click="getItemCategory('change')" variant="outline-info"><i
                class="mdi mdi-clipboard-text-search-outline"></i></b-button>
          </template>
          <input autocomplete="off" type="text" disabled placeholder="Search Item Category..." class="form-control"
            :class="{
              'is-invalid': submitted && itemCategoryIdChange == null
            }" v-model="itemCategoryChange" />
        </b-input-group>
        <div v-if="submitted && itemCategoryIdChange == null" class="invalid-feedback">
          <span>This value is required.</span>
        </div>
      </div>
      <div v-else-if="multipleUpdateType == 'dateAcquired'">
        <label for="dateAcquired">Date Acquired </label>
        <date-picker v-model="dateAcquiredChange" :first-day-of-week="1" lang="en" placeholder="Enter Date Acquired..."
          :class="{
            'is-invalid':
              submitted &&
              (dateAcquiredChange == null || dateAcquiredChange == '')
          }"></date-picker>
        <div v-if="
          submitted &&
          (dateAcquiredChange == null || dateAcquiredChange == '')
        " class="invalid-feedback">
          <span>This value is required.</span>
        </div>
      </div>
      <div v-else-if="multipleUpdateType == 'dateAssigned'">
        <label for="dateAssigned">Date Assigned </label>
        <date-picker v-model="dateAssignedChange" :first-day-of-week="1" lang="en" placeholder="Enter Date Assigned..."
          :class="{
            'is-invalid':
              submitted &&
              (dateAssignedChange == null || dateAssignedChange == '')
          }"></date-picker>
        <div v-if="
          submitted &&
          (dateAssignedChange == null || dateAssignedChange == '')
        " class="invalid-feedback">
          <span>This value is required.</span>
        </div>
      </div>
      <div v-else-if="multipleUpdateType == 'cost'">
        <label for="amount">Amount / Unit Cost </label>
        <masked-input id="amount" type="text" v-model="unitCostChange" placeholder="Enter Amount / Unit Cost..."
          class="form-control" :class="{
            'is-invalid':
              submitted && (unitCostChange == null || unitCostChange == '')
          }" autocomplete="off" :mask="currencyMask"></masked-input>
        <div v-if="submitted && (unitCostChange == null || unitCostChange == '')" class="invalid-feedback">
          <span>This value is required.</span>
        </div>
      </div>
      <div v-else-if="multipleUpdateType == 'location'">
        <label for="amount">Location </label>
        <b-input-group>
          <template #append>
            <b-button @click="getLocation('change')" variant="outline-info"><i
                class="mdi mdi-clipboard-text-search-outline"></i></b-button>
          </template>
          <input autocomplete="off" type="text" disabled placeholder="Search Location..." class="form-control"
            v-model="locationChange" />
        </b-input-group>
        <div v-if="
          submitted && (locationIdChange == null || locationIdChange == '')
        " class="invalid-feedback">
          <span>This value is required.</span>
        </div>
      </div>
      <div v-else-if="multipleUpdateType == 'condition'">
        <label for="condition">Condition </label>
        <b-form-select class="form-select" :class="{
          'is-invalid':
            submitted && (conditionChange == null || conditionChange == '')
        }" v-model="conditionChange">
          <b-form-select-option value="" disabled>Select Condition...</b-form-select-option>
          <b-form-select-option value="In good condition">In good condition</b-form-select-option>
          <b-form-select-option value="Needing Repair">Needing Repair</b-form-select-option>
          <b-form-select-option value="Unserviceable">Unserviceable</b-form-select-option>
          <b-form-select-option value="Obsolete">Obsolete</b-form-select-option>
          <b-form-select-option value="Expired">Expired</b-form-select-option>
          <b-form-select-option value="No longer needed">No longer needed</b-form-select-option>
          <b-form-select-option value="Not used since purchase">Not used since purchase</b-form-select-option>
        </b-form-select>
        <div v-if="submitted && (conditionChange == null || conditionChange == '')" class="invalid-feedback">
          <span>This value is required.</span>
        </div>
      </div>
      <div class="d-flex justify-content-end">
        <button class="btn btn-primary mt-3" type="button" id="inputGroupFileAddon04" @click="onChangeMultiple">
          Change
        </button>
      </div>
    </b-modal>
    <!-- Print ICF -->
    <b-modal id="icf-modal" title="Print ICF" size="md" title-class="font-18" hide-footer no-close-on-backdrop>
      <p class="text-muted mb-0">Print ICF By</p>
      <select class="form-select mt-2 mb-4" v-model="getByPrint">
        <option value="1">Current {{GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}}</option>
        <option value="2">Employee (PPE)</option>
        <option value="5">Employee (High Value)</option>
        <option value="6">Employee (Low Value)</option>
        <option value="3">Employee (All)</option>
        <option value="4">Location</option>
      </select>
      <b-collapse :visible="getByPrint == 1">
        <div v-if="getByPrint == 1">
          <button type="button" @click="printIcf"
            class="btn btn-md btn-block btn-primary d-flex align-items-center justify-content-center mb-2">
            <i class="bx bx-print fs-6 me-2"></i>Print
          </button>
        </div>
      </b-collapse>
      <b-collapse :visible="isICFEmployee">
        <div v-if="isICFEmployee">
          <div class="mb-3">
            <b-input-group>
              <template #append>
                <b-button @click="getEmployee('print')" variant="outline-info"><i
                    class="mdi mdi-clipboard-text-search-outline"></i></b-button>
              </template>
              <input autocomplete="off" type="text" disabled placeholder="Search Employee..." class="form-control"
                :class="{
                  'is-invalid':
                    submitted &&
                    (employeeIdNumberPrint == '' ||
                      employeeIdNumberPrint == null)
                }" v-model="employeeNamePrint" />
            </b-input-group>
            <div v-if="
              submitted &&
              (employeeIdNumberPrint == '' || employeeIdNumberPrint == null)
            " class="invalid-feedback">
              <span>This value is required.</span>
            </div>
          </div>
          <button type="button" @click="printIcfEmployee"
            class="btn btn-md btn-block btn-primary d-flex align-items-center justify-content-center mb-2">
            <i class="bx bx-download fs-6 me-2"></i>Print
          </button>
        </div>
      </b-collapse>
      <b-collapse :visible="getByPrint == 3">
        <div v-if="getByPrint == 3">
          <div class="mb-3">
            <b-input-group>
              <template #append>
                <b-button @click="getEmployee('print')" variant="outline-info"><i
                    class="mdi mdi-clipboard-text-search-outline"></i></b-button>
              </template>
              <input autocomplete="off" type="text" disabled placeholder="Search Employee..." class="form-control"
                :class="{
                  'is-invalid':
                    submitted &&
                    (employeeIdNumberPrint == '' ||
                      employeeIdNumberPrint == null)
                }" v-model="employeeNamePrint" />
            </b-input-group>
            <div v-if="
              submitted &&
              (employeeIdNumberPrint == '' || employeeIdNumberPrint == null)
            " class="invalid-feedback">
              <span>This value is required.</span>
            </div>
          </div>
          <button type="button" @click="printIcfEmployeeAll"
            class="btn btn-md btn-block btn-primary d-flex align-items-center justify-content-center mb-2">
            <i class="bx bx-download fs-6 me-2"></i>Print
          </button>
        </div>
      </b-collapse>
      <b-collapse :visible="getByPrint == 4">
        <div v-if="getByPrint == 4">
          <div class="mb-3">
            <b-input-group>
              <template #append>
                <b-button @click="getLocation('print')" variant="outline-info"><i
                    class="mdi mdi-clipboard-text-search-outline"></i></b-button>
              </template>
              <input autocomplete="off" type="text" disabled placeholder="Search Location..." class="form-control"
                :class="{
                  'is-invalid':
                    submitted &&
                    (locationIdPrint == '' || locationIdPrint == null)
                }" v-model="locationNamePrint" />
            </b-input-group>
            <div v-if="
              submitted && (locationIdPrint == '' || locationIdPrint == null)
            " class="invalid-feedback">
              <span>This value is required.</span>
            </div>
          </div>
          <button type="button" @click="printIcfLocation"
            class="btn btn-md btn-block btn-primary d-flex align-items-center justify-content-center mb-2">
            <i class="bx bx-download fs-6 me-2"></i>Print
          </button>
        </div>
      </b-collapse>
    </b-modal>
    <!-- Print RPCPPE -->
    <b-modal id="ppe-modal" :title="`Print ${rpType.toUpperCase()}`" size="md" title-class="font-18" hide-footer no-close-on-backdrop>
      <p class="text-muted mb-2">Print {{ rpType.toUpperCase() }} By Employee</p>
      <div class="mb-3">
        <b-input-group>
          <template #append>
            <b-button @click="getEmployee('print')" variant="outline-info"><i
                class="mdi mdi-clipboard-text-search-outline"></i></b-button>
          </template>
          <input autocomplete="off" type="text" disabled placeholder="Search Employee..." class="form-control" :class="{
            'is-invalid':
              submitted &&
              (employeeIdNumberPrint == '' || employeeIdNumberPrint == null)
          }" v-model="employeeNamePrint" />
        </b-input-group>
        <div v-if="
          submitted &&
          (employeeIdNumberPrint == '' || employeeIdNumberPrint == null)
        " class="invalid-feedback">
          <span>This value is required.</span>
        </div>
      </div>
      <button type="button" @click="printPpeEmployee(rpType)"
        class="btn btn-md btn-block btn-primary d-flex align-items-center justify-content-center mb-2">
        <i class="bx bx-download fs-6 me-2"></i>Print
      </button>
    </b-modal>
    <!-- Cart -->
    <b-modal id="modal-cart" :title="`Cart: ${selectedProperties.length}
                                            ${selectedProperties.length > 1
        ? 'Properties'
        : 'Property'
      }`
      " size="xl" title-class="font-18" hide-footer no-close-on-backdrop>
      <div class="d-flex justify-content-between align-items-center mb-2">
        <div class="d-flex justify-content-between align-items-center">
          <b-dropdown id="dropdown-bottom" right variant="link" toggle-class="text-decoration-none p-0"
            menu-class="dropdown-menu-bottom" no-caret>
            <template #button-content>
              <button type="button" class="btn btn-sm btn-purple d-flex align-items-center justify-content-center me-1">
                <i class="bx bx-printer fs-6 me-1"></i>Print Documents
              </button>
            </template>
            <b-dropdown-item v-if="
              checkPropertyType(filteredCart) == 1 ||
              checkPropertyType(filteredCart) == 3
            " @click="printParMultiple()"><i class="bx bx-printer font-size-18 text-purple me-1"></i>Print
              PAR</b-dropdown-item>
            <b-dropdown-item v-if="
              checkPropertyType(filteredCart) == 2 ||
              checkPropertyType(filteredCart) == 3
            " @click="printIcsMultiple()"><i class="bx bx-printer font-size-18 text-purple me-1"></i>Print
              ICS</b-dropdown-item>
            <b-dropdown-item @click="printStickerMultiple()"><i
                class="bx bx-printer font-size-18 text-purple me-1"></i>Print
              Sticker</b-dropdown-item>
          </b-dropdown>
          <b-dropdown id="dropdown-bottom" right variant="link" toggle-class="text-decoration-none p-0"
            menu-class="dropdown-menu-bottom" no-caret>
            <template #button-content>
              <button type="button"
                class="btn btn-sm btn-success d-flex align-items-center justify-content-center me-1">
                <i class="bx bx-right-arrow-circle fs-6 me-1"></i>Actions
              </button>
            </template>
            <b-dropdown-item @click="addInventory()"><i class="bx bx-box font-size-18 text-success me-1"></i>Add to
              Inventory</b-dropdown-item>
            <b-dropdown-item @click="transferCampus()"><i
                class="bx bx-transfer font-size-18 text-primary me-1"></i>Transfer
              {{GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}}</b-dropdown-item>
            <b-dropdown-item @click="transferMultipleItems()"><i
                class="bx bx-user font-size-18 text-info me-1"></i>Transfer
              Assignment</b-dropdown-item>
            <b-dropdown-item @click="returnMultipleItems()"><i
                class="bx bx-revision font-size-18 text-warning me-1"></i>Return Items</b-dropdown-item>
          </b-dropdown>
          <!-- <button
            type="button"
            @click="addInventory()"
            class="btn btn-sm btn-success d-flex align-items-center justify-content-center me-1"
          >
            <i class="bx bx-box fs-6 me-1"></i>Add to Inventory
          </button>
          <button
            type="button"
            @click="transferCampus()"
            class="btn btn-sm btn-primary d-flex align-items-center justify-content-center me-1"
          >
            <i class="bx bx-transfer fs-6 me-1"></i>Transfer Campus
          </button>
          <button
            type="button"
            @click="returnMultipleItems()"
            class="btn btn-sm btn-warning d-flex align-items-center justify-content-center me-1"
          >
            <i class="bx bx-revision fs-6 me-1"></i>Return Items
          </button> -->
          <b-dropdown id="dropdown-dropleft" right variant="info" toggle-class="text-decoration-none"
            menu-class="dropdown-menu-end" size="sm" no-caret>
            <template #button-content>
              <div class="d-flex align-items-center">
                <i class="bx bx-edit fs-6 me-1"></i>Update Selected
              </div>
            </template>
            <b-dropdown-item @click="changeItemCategory()" variant="info"><i
                class="mdi mdi-format-list-text font-size-18 me-1"></i>Change
              Category</b-dropdown-item>
            <b-dropdown-item @click="changeDateAcquired()" variant="info"><i
                class="mdi mdi-calendar-month font-size-18 me-1"></i>Change
              Date Acquired</b-dropdown-item>
            <b-dropdown-item @click="changeDateAssigned()" variant="info"><i
                class="mdi mdi-calendar-account-outline font-size-18 me-1"></i>Change Date Assigned</b-dropdown-item>
            <b-dropdown-item @click="changeUnitCost()" variant="info"><i
                class="mdi mdi-cash-multiple font-size-18 me-1"></i>Change
              Unit Cost</b-dropdown-item>
            <b-dropdown-item @click="changeLocation()" variant="info"><i
                class="mdi mdi-map-marker font-size-18 me-1"></i>Change
              Location</b-dropdown-item>
            <b-dropdown-item @click="changeCondition()" variant="info"><i
                class="mdi mdi-clipboard-edit-outline font-size-18 me-1"></i>Change Condition</b-dropdown-item>
          </b-dropdown>
        </div>
        <div class="d-flex align-items-center">
          <b-button title="Remove All from Cart" class="me-2" @click="clearCart()" variant="outline-danger"><i
              class="mdi mdi-cart-remove"></i></b-button>
          <b-form-input autocomplete="off" v-model="filterCart" type="search" @input="currentPageCart = 1"
            placeholder="Search Properties..." class="form-control"></b-form-input>
        </div>
      </div>
      <div class="custom-table-responsive mb-0">
        <b-table class="propertyTable datatables target-table" thead-class="d-none" :items="filteredCart"
          :fields="propertyFields" responsive="sm" :per-page="perPageCart" :current-page="currentPageCart" sort-by="id"
          :sort-desc.sync="sortDesc" :busy="false" show-empty>
          <template #empty>
            <b-card-header>
              <div class="text-center">
                <div v-if="filterCart != ''">
                  <i class="fas fa-exclamation-triangle me-2"></i>There are no
                  properties matching your request
                </div>
                <div v-else>
                  <i class="fas fa-exclamation-triangle me-2"></i>No properties
                  available
                </div>
              </div>
            </b-card-header>
          </template>
          <template #table-busy>
            <b-card-header>
              <div class="d-flex justify-content-center align-items-center p-2">
                <div class="preloader-component me-2">
                  <div class="status">
                    <div class="spinner-chase w-20px h-20px">
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                    </div>
                  </div>
                </div>
                <strong>Loading...</strong>
              </div>
            </b-card-header>
          </template>
          <template #cell(name)="propertyRow">
            <div class="position-relative ms-1">
              <RawData :data="propertyRow.item" :keyId="`cart-${propertyRow.item.id}`"
                v-if="$store.state.decrypt.isAdmin()" placement="bottom left"/>
            </div>
            <b-card-header header-tag="header" role="tab" class="border">
              <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center pe-5">
                  <div :style="propertyNumberWidth(
                    (currentPageCart - 1) * perPageCart +
                    (propertyRow.index + 1)
                  )
                    " class="bg-success bg-gradient text-center me-2 py-1 position-relative">
                    <h3 class="mb-0 position-relative">
                      {{
                        (currentPageCart - 1) * perPageCart +
                        (propertyRow.index + 1)
                      }}
                    </h3>
                  </div>
                  <div class="text-muted">
                    <h5 class="mb-0">
                      {{ propertyRow.item.name }}
                    </h5>
                    <div>
                      <small class="d-flex align-items-center">{{
                        propertyRow.item.propertyNumber &&
                          propertyRow.item.propertyNumber != "Not Indicated"
                          ? `Property# ${propertyRow.item.propertyNumber}`
                          : "Not Indicated"
                      }}
                      </small>
                    </div>
                  </div>
                </div>
                <div class="d-flex justify-content-between align-items-center ms-5">
                  <div style="width: 200px" class="d-flex align-items-center">
                    <div class="text-muted">
                      <div>
                        <small class="d-flex align-items-center">
                          Current Value:
                        </small>
                      </div>
                      <h6 class="mb-0 text-warning">
                        {{ formatCurrency(propertyRow.item.currentValue) }}
                      </h6>
                    </div>
                  </div>
                  <div class="float-end d-flex align-items-center ms-3">
                    <i title="Remove From Cart" class="bx bx-x font-size-18 text-danger cursor-pointer ms-2 me-2"
                      @click="removeFromCart(propertyRow.item)"></i>
                  </div>
                </div>
              </div>
            </b-card-header>
          </template>
        </b-table>
      </div>
      <div class="row my-2">
        <div v-if="rowsCart > 0" class="col">
          Showing {{ (currentPageCart - 1) * perPageCart + 1 }} -
          {{
            rowsCart > (currentPageCart - 1) * perPageCart + perPageCart
              ? (currentPageCart - 1) * perPageCart + perPageCart
              : rowsCart
          }}
          of {{ rowsCart }}
        </div>
        <div class="col">
          <div class="dataTables_paginate paging_simple_numbers float-end">
            <ul class="pagination pagination-rounded mb-0" style="z-index: -1">
              <!-- pagination -->
              <b-pagination v-model="currentPageCart" :total-rows="rowsCart" :per-page="perPageCart"></b-pagination>
            </ul>
          </div>
        </div>
      </div>
    </b-modal>
    <!-- Main -->
    <div class="row">
      <!-- Side Bar -->
      <div class="col-md-3">
        <!-- Print -->
        <b-dropdown id="dropdown-dropleft" right variant="purple btn-sm" toggle-class="text-decoration-none"
          menu-class="dropdown-menu-start" class="mb-2" no-caret>
          <template #button-content>
            <i class="bx bx-printer me-1"></i>
            Reports
          </template>
          <b-dropdown-item @click="getIcf">Print ICF</b-dropdown-item>
          <b-dropdown-item @click="getPpe('rpcppe')">Print RPCPPE</b-dropdown-item>
          <b-dropdown-item @click="getPpe('rpcsp')">Print RPCSP</b-dropdown-item>
          <b-dropdown-item @click="getEmployeeWithProperties">Print Employee with Properties</b-dropdown-item>
          <b-dropdown-item @click="getEmployeeWithSemiExProperties">Print Employee with Semi-exp Properties</b-dropdown-item>
        </b-dropdown>
        <!-- Get By -->
        <div class="card border-4 border-top border-start-0 border-end-0 border-primary">
          <div class="card-body pt-3 pb-3 ps-4 pe-4">
            <b>Get Properties By</b>
            <select @change="getProperties" class="form-select mt-3" v-model="getBy">
              <option value="1">Search</option>
              <option value="2">All Properties</option>
            </select>
            <b-collapse :visible="getByValue == 1">
              <div v-if="getByValue == 1">
                <hr class="my-3" />
                <div class="d-flex gap-1 mt-3">
                  <div
                    class="
                      form-check
                      form-checkbox-outline
                      form-check-success
                      mb-0
                    "
                  >
                    <input
                      type="checkbox"
                      id="showEOL"
                      checked="checked"
                      class="form-check-input"
                      v-model="showEOL"
                    /><label
                      for="showEOL"
                      class="form-check-label"
                    >
                      Show Expired Properties
                    </label>
                  </div>
                  <div
                    class="
                      form-check
                      form-checkbox-outline
                      form-check-success
                      mb-0
                      ms-4
                    "
                  >
                    <input
                      type="checkbox"
                      id="showConsumables"
                      checked="checked"
                      class="form-check-input"
                      v-model="showConsumables"
                    /><label
                      for="showConsumables"
                      class="form-check-label"
                    >
                      Show Consumables
                    </label>
                  </div>
                </div>
                <!-- P.O. # -->
                <div class="mt-2 mb-1">P.O. Number</div>
                <div id="poNumber" class="position-relative">
                  <input autocomplete="off" type="text" class="form-control rounded border-light"
                    placeholder="Input PO Number..." v-model="poNumber" v-on:keyup.enter="getBySearch" />
                </div>
                <!-- Property # -->
                <div class="mt-2 mb-1">Property Number</div>
                <div id="propertyNumber" class="position-relative">
                  <input autocomplete="off" type="text" class="form-control rounded border-light"
                    placeholder="Input Property Number..." v-model="propertyNumber" v-on:keyup.enter="getBySearch" />
                </div>
                <!-- Property Name -->
                <div class="mt-2 mb-1">Property Name</div>
                <div id="propertyName" class="position-relative">
                  <input autocomplete="off" type="text" class="form-control rounded border-light"
                    placeholder="Input Property Name..." v-model="propertyName" v-on:keyup.enter="getBySearch" />
                </div>
                <!-- Employee -->
                <div class="mt-2 mb-1">Employee</div>
                <b-input-group>
                  <template #append>
                    <b-button v-if="employeeId == ''" @click="getEmployee('get')" variant="outline-info"><i
                        class="mdi mdi-clipboard-text-search-outline"></i></b-button>
                    <b-button v-else @click="removeEmployee('get')" variant="outline-danger" title="Remove Employee"><i
                        class="mdi mdi-close-thick"></i></b-button>
                  </template>
                  <input autocomplete="off" type="text" disabled placeholder="Select Employee..."
                    class="form-control rounded border-light" v-model="employeeNameGet" />
                </b-input-group>
                <!-- PAR/ICS -->
                <div class="mt-2 mb-1">PAR/ICS Number</div>
                <div id="assignmentNumber" class="position-relative">
                  <input autocomplete="off" type="text" class="form-control rounded border-light"
                    placeholder="Input PAR/ICS Number..." v-model="assignmentNumber" v-on:keyup.enter="getBySearch" />
                </div>
                <!-- Location -->
                <div class="mt-2 mb-1">Location</div>
                <b-input-group>
                  <template #append>
                    <b-button v-if="locationIdSelected == 0" @click="getLocation('get')" variant="outline-info"><i
                        class="mdi mdi-clipboard-text-search-outline"></i></b-button>
                    <b-button v-else @click="removeLocation('get')" variant="outline-danger"><i
                        class="mdi mdi-close-thick"></i></b-button>
                  </template>
                  <input autocomplete="off" type="text" disabled placeholder="Search Location..."
                    class="form-control rounded border-light" v-model="locationGet" />
                </b-input-group>
                <!-- Fund Cluster -->
                <div class="mt-2 mb-1">Fund Cluster</div>
                <b-input-group>
                  <template #append>
                    <b-button v-if="fundClusterId == 0" @click="getFundCluster('get')" variant="outline-info"><i
                        class="mdi mdi-clipboard-text-search-outline"></i></b-button>
                    <b-button v-else @click="removeFundCluster('get')" variant="outline-danger"
                      title="Remove Fund Cluster"><i class="mdi mdi-close-thick"></i></b-button>
                  </template>
                  <input autocomplete="off" type="text" disabled placeholder="Search Fund Cluster..."
                    class="form-control rounded border-light" v-model="fundClusterGet" />
                </b-input-group>
                <!-- Category -->
                <div class="mt-2 mb-1">Item Category</div>
                <b-input-group>
                  <template #append>
                    <b-button v-if="itemCategoryId == 0" @click="getItemCategory('get')" variant="outline-info"><i
                        class="mdi mdi-clipboard-text-search-outline"></i></b-button>
                    <b-button v-else @click="removeItemCat('get')" variant="outline-danger"
                      title="Remove Item Category"><i class="mdi mdi-close-thick"></i></b-button>
                  </template>
                  <input autocomplete="off" type="text" disabled placeholder="Search Item Category..."
                    class="form-control rounded border-light" v-model="itemCategoryGet" />
                </b-input-group>
                <!-- Year -->
                <div class="mt-2 mb-1">Year</div>
                <date-picker id="year" v-model="itemYear" :first-day-of-week="1" type="year" lang="en"
                  class="rounded border-light" placeholder="Select Year..." @change="getBySearch"></date-picker>
                <!-- Cost -->
                <div class="mt-2 mb-1">Cost</div>
                <div class="d-flex justify-content-between">
                  <div class="me-3">
                    <masked-input id="minCost" type="text" v-model="minCost" placeholder="Min Cost..."
                      class="form-control rounded border-light" :class="{
                        'is-invalid': compareCost == 1
                      }" autocomplete="off" :mask="currencyMask" v-on:keyup.enter="getBySearch"></masked-input>
                    <div v-if="compareCost == 1" class="invalid-feedback">
                      <span v-if="!$v.form.amount.required">This value is required.</span>
                    </div>
                  </div>
                  <div>
                    <masked-input id="maxCost" type="text" v-model="maxCost" placeholder="Max Cost..."
                      class="form-control rounded border-light" :class="{
                        'is-invalid': compareCost == 1
                      }" autocomplete="off" :mask="currencyMask" v-on:keyup.enter="getBySearch"></masked-input>
                    <div v-if="compareCost == 1" class="invalid-feedback">
                      <span>Max Cost should be greater than Min Cost.</span>
                    </div>
                  </div>
                </div>
                <!-- Get -->
                <hr class="my-3" />
                <button type="button" @click="getBySearch"
                  class="btn btn-md btn-block btn-primary d-flex align-items-center justify-content-center mt-3 mb-1">
                  <i class="bx bx-download fs-6 me-2"></i>Get Properties
                </button>
              </div>
            </b-collapse>
          </div>
        </div>
      </div>
      <!-- Properties -->
      <div class="col-md-9">
        <transition name="slide">
          <div v-if="bySearch">
            <b-tabs content-class="pt-3 pb-3 text-muted" v-model="tabIndex" nav-class="nav-tabs-custom">
              <b-tab @click="byFiltered = false">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="mdi mdi-shopping-outline"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Show All</span>
                </template>
                <div v-if="tabIndex == 0" class="card border-4 border-top border-start-0 border-end-0 border-primary">
                  <div class="card-body">
                    <div class="row mb-1">
                      <div class="col-md-6">
                        <div>
                          <h5 class="m-0 mb-1">List of Properties</h5>
                          <transition name="fade">
                            <h6 v-if="employeeData && employeeData.firstName" class="m-0 d-flex align-items-center">
                              {{
                                employeeData.firstName.charAt(0).toUpperCase() +
                                employeeData.firstName.slice(1)
                              }}
                              {{
                                employeeData.middleName
                                  ? `${employeeData.middleName
                                    .charAt(0)
                                    .toUpperCase()}.`
                                  : ""
                              }}
                              {{
                                employeeData.lastName.charAt(0).toUpperCase() +
                                employeeData.lastName.slice(1)
                              }}
                              <i @click="showEmployee(employeeData)" v-b-tooltip.top.hover="'Print Records'"
                                class="bx bx-printer text-purple font-size-18 cursor-pointer ms-1"></i>
                            </h6>
                          </transition>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="d-flex float-end align-items-center">
                          <transition name="fade">
                            <div v-if="filtered.length > 0" class="d-flex align-items-center">
                              <b-button :title="`Add ${filter.trim() == '' ? '' : 'Searched '
                                }Properties to Cart`
                                " class="me-1" @click="
                                  addAllToCart(grouped, currentPage, perPage)
                                  " variant="outline-info"><i class="mdi mdi-cart-outline"></i></b-button>
                              <b-button :title="`Remove ${filter.trim() == '' ? '' : 'Searched '
                                }Properties from Cart`
                                " class="me-2" @click="
                                  removeAllFromCart(
                                    grouped,
                                    currentPage,
                                    perPage
                                  )
                                  " variant="outline-danger"><i class="mdi mdi-cart-remove"></i></b-button>
                            </div>
                          </transition>
                          <div id="tickets-table_filter" class="dataTables_filter me-1">
                            <label class="d-inline-flex align-items-center mb-0">
                              <b-form-input autocomplete="off" v-model="filter" type="search" @input="currentPage = 1"
                                placeholder="Search Property..." class="form-control"></b-form-input>
                            </label>
                          </div>
                          <div id="tickets-table_length" class="dataTables_length">
                            <label class="d-inline-flex align-items-center mb-0">
                              <b-form-select class="form-select" v-model="perPage" size="sm" :options="pageOptionsLg">
                              </b-form-select>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="custom-table-responsive mb-0 mt-2">
                      <b-table class="propertyTable datatables target-table" :items="grouped" :fields="propertyFields"
                        responsive="sm" :per-page="perPage" :current-page="currentPage" :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc" :busy="tableBusy" bordered outlined striped show-empty>
                        <template #empty>
                          <b-card-header>
                            <div class="text-center">
                              <div v-if="filter != ''">
                                <i class="fas fa-exclamation-triangle me-2"></i>There are no properties matching your
                                request
                              </div>
                              <div v-else>
                                <i class="fas fa-exclamation-triangle me-2"></i>No properties available
                              </div>
                            </div>
                          </b-card-header>
                        </template>
                        <template #table-busy>
                          <b-card-header>
                            <div class="d-flex justify-content-center align-items-center p-2">
                              <div class="preloader-component me-2">
                                <div class="status">
                                  <div class="spinner-chase w-20px h-20px">
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                  </div>
                                </div>
                              </div>
                              <strong>Loading...</strong>
                            </div>
                          </b-card-header>
                        </template>
                        <template #cell(name)="propertyRow">
                          <div class="position-relative ms-1">
                            <RawData :data="propertyRow.item" :keyId="`search-showAll-${propertyRow.item.id}`"
                              v-if="$store.state.decrypt.isAdmin()" />
                          </div>
                          <b-card-header header-tag="header" role="tab" class="border">
                            <div class="d-flex justify-content-between align-items-center">
                              <div class="d-flex align-items-center pe-5">
                                <div :style="propertyNumberWidth(
                                  (currentPage - 1) * perPage +
                                  (propertyRow.index + 1)
                                )
                                  " class="bg-success bg-gradient text-center me-2 py-1 position-relative">
                                  <h3 class="mb-0 position-relative">
                                    {{
                                      (currentPage - 1) * perPage +
                                      (propertyRow.index + 1)
                                    }}
                                  </h3>
                                </div>
                                <div class="text-muted">
                                  <h5 class="mb-0">
                                    {{ propertyRow.item.name }}
                                  </h5>
                                  <div style="min-width: max-content">
                                    <small class="d-flex align-items-center">{{
                                      propertyRow.item.propertyNumber &&
                                        propertyRow.item.propertyNumber !=
                                        "Not Indicated"
                                        ? `Property# ${propertyRow.item.propertyNumber}`
                                        : "Not Indicated"
                                    }}
                                      |
                                      <a href="javascript: void(0);" class="text-success d-flex align-items-center ms-1"
                                        @click="
                                          propertyRow.item.visible = !propertyRow
                                            .item.visible
                                          ">
                                        {{
                                          propertyRow.item.visible
                                            ? "Hide"
                                            : "Show"
                                        }}
                                        Details
                                        <i class="bx bx-chevron-right rotate font-size-14" :class="{
                                          'rotate-90':
                                            propertyRow.item.visible
                                        }"></i>
                                      </a>
                                    </small>
                                  </div>
                                </div>
                              </div>
                              <div class="d-flex justify-content-between align-items-center ms-5">
                                <div style="width: 200px" class="d-flex align-items-center">
                                  <div class="text-muted">
                                    <div>
                                      <small class="d-flex align-items-center">
                                        Current Value:
                                      </small>
                                    </div>
                                    <h6 class="mb-0 text-warning">
                                      {{
                                        formatCurrency(
                                          propertyRow.item.currentValue
                                        )
                                      }}
                                    </h6>
                                  </div>
                                </div>
                                <div class="float-end d-flex align-items-center ms-3">
                                  <i v-if="checkCart(propertyRow.item)" title="Add to Cart"
                                    class="mdi mdi-cart-outline font-size-18 text-info cursor-pointer me-1"
                                    @click="addToCart(propertyRow.item)"></i>
                                  <i v-else title="Remove from Cart"
                                    class="mdi mdi-cart-remove font-size-18 text-danger cursor-pointer me-1"
                                    @click="removeFromCart(propertyRow.item)"></i>
                                  <i class="bx bx-printer font-size-18 text-purple cursor-pointer ms-2" :id="`all-print-popover-${propertyRow.item.id}`
                                    " tabindex="0"></i>
                                  <b-popover :target="`all-print-popover-${propertyRow.item.id}`
                                    " triggers="click blur" placement="leftbottom" variant="secondary"
                                    custom-class="p-0">
                                    <b-list-group class="w-100 fit">
                                      <b-list-group-item v-if="propertyRow.item.amount >= 50000" button action
                                        class="d-flex align-items-center" @click="
                                          printParProperty(propertyRow.item.id)
                                          "><i class="bx bx-printer text-purple font-size-18 me-1"></i>Print
                                        PAR</b-list-group-item>
                                      <b-list-group-item v-else button action class="d-flex align-items-center" @click="
                                        printIcsProperty(propertyRow.item.id)
                                        "><i class="bx bx-printer text-purple font-size-18 me-1"></i>Print
                                        ICS</b-list-group-item>
                                      <b-list-group-item button action class="d-flex align-items-center" @click="
                                        printStickerProperty(
                                          propertyRow.item.id
                                        )
                                        "><i class="bx bx-printer text-purple font-size-18 me-1"></i>Print
                                        Sticker</b-list-group-item>
                                      <b-list-group-item button action class="d-flex align-items-center" @click="
                                        printPropertyCard(
                                          propertyRow.item.id
                                        )
                                        "><i class="bx bx-printer text-purple font-size-18 me-1"></i>Print
                                        Property Card</b-list-group-item>
                                    </b-list-group>
                                  </b-popover>
                                  <i class="fas fa-ellipsis-v cursor-pointer ps-2 pe-2 ms-2"
                                    :id="`all-popover-${propertyRow.item.id}`" tabindex="0"></i>
                                  <b-popover :target="`all-popover-${propertyRow.item.id}`
                                    " triggers="click blur" placement="leftbottom" variant="secondary"
                                    custom-class="p-0">
                                    <b-list-group class="w-100 fit">
                                      <b-list-group-item button action class="d-flex align-items-center text-info"
                                        @click="
                                          updateItem(propertyRow.item, null)
                                          "><i class="mdi mdi-update font-size-18 me-1"></i>Update
                                        Item</b-list-group-item>
                                    </b-list-group>
                                  </b-popover>
                                </div>
                              </div>
                            </div>
                          </b-card-header>
                          <b-collapse :visible="propertyRow.item.visible" role="tabpanel">
                            <div v-if="propertyRow.item.visible">
                              <b-card no-body
                                class="shadow-none mb-0 border-5 border-top-0 border-start-0 border-end-0">
                                <Details :key="`all-details-${propertyRow.item.id}`" :propertyRow="propertyRow.item"
                                  :ref="`all-details-${propertyRow.item.id}`"></Details>
                                <AssignmentHistory :key="`all-assignment-${propertyRow.item.id}`"
                                  :propertyRow="propertyRow.item" :allowAssign="false" :allowEdit="true"
                                  :allowTransfer="true" :employeeData="assignmentHistoryEmployeeData"
                                  :locationData="assignmentHistoryLocationData"
                                  :ref="`all-assignment-${propertyRow.item.id}`" @getEmployee="getEmployee($event)"
                                  @getLocation="getLocation($event)"></AssignmentHistory>
                                <CurrentInventory :key="`all-inventory-${propertyRow.item.id}`"
                                  :propertyRow="propertyRow.item" :ref="`all-inventory-${propertyRow.item.id}`">
                                </CurrentInventory>
                                <InspectionHistory :key="`all-inspection-${propertyRow.item.id}`"
                                  :propertyRow="propertyRow.item" :ref="`all-inspection-${propertyRow.item.id}`">
                                </InspectionHistory>
                                <Attachments :key="`all-attachments-${propertyRow.item.id}`
                                  " :propertyRow="propertyRow.item" :ref="`all-attachments-${propertyRow.item.id}`
                                    "></Attachments>
                              </b-card>
                            </div>
                          </b-collapse>
                        </template>
                      </b-table>
                    </div>
                    <div class="row">
                      <div v-if="rows > 0" class="col">
                        Showing {{ (currentPage - 1) * perPage + 1 }} -
                        {{
                          rows > (currentPage - 1) * perPage + perPage
                            ? (currentPage - 1) * perPage + perPage
                            : rows
                        }}
                        of {{ rows }}
                      </div>
                      <div class="col">
                        <div class="dataTables_paginate paging_simple_numbers float-end">
                          <ul class="pagination pagination-rounded mb-0" style="z-index: -1">
                            <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </b-tab>
              <b-tab @click="byFiltered = true">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="mdi mdi-filter-outline"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Filter by PO</span>
                </template>
                <div v-if="tabIndex == 1" class="card border-4 border-top border-start-0 border-end-0 border-primary">
                  <div class="card-body">
                    <div class="row mb-1">
                      <div class="col-md-6">
                        <div>
                          <h5 class="m-0 mb-1">List of Properties</h5>
                          <transition name="fade">
                            <h6 v-if="employeeData && employeeData.firstName" class="m-0 d-flex align-items-center">
                              {{
                                employeeData.firstName.charAt(0).toUpperCase() +
                                employeeData.firstName.slice(1)
                              }}
                              {{
                                employeeData.middleName
                                  ? `${employeeData.middleName
                                    .charAt(0)
                                    .toUpperCase()}.`
                                  : ""
                              }}
                              {{
                                employeeData.lastName.charAt(0).toUpperCase() +
                                employeeData.lastName.slice(1)
                              }}
                              <i @click="showEmployee(employeeData)" v-b-tooltip.top.hover="'Print Records'"
                                class="bx bx-printer text-purple font-size-18 cursor-pointer ms-1"></i>
                            </h6>
                          </transition>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="d-flex float-end align-items-center">
                          <div id="tickets-table_filter" class="dataTables_filter me-1">
                            <label class="d-inline-flex align-items-center mb-0">
                              <b-form-input autocomplete="off" v-model="filter" type="search" @input="currentPage = 1"
                                placeholder="Search Property..." class="form-control"></b-form-input>
                            </label>
                          </div>
                          <div id="tickets-table_length" class="dataTables_length">
                            <label class="d-inline-flex align-items-center mb-0">
                              <b-form-select class="form-select" v-model="perPage" size="sm" :options="pageOptionsLg">
                              </b-form-select>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="custom-table-responsive mb-0 mt-2">
                      <b-table class="propertyTable datatables target-table" :items="grouped" :fields="fields"
                        responsive="sm" :per-page="perPage" :current-page="currentPage" :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc" :busy="tableBusy" bordered outlined striped show-empty>
                        <template #empty>
                          <b-card-header>
                            <div class="text-center">
                              <div v-if="filter != ''">
                                <i class="fas fa-exclamation-triangle me-2"></i>There are no POs matching your request
                              </div>
                              <div v-else>
                                <i class="fas fa-exclamation-triangle me-2"></i>No properties available
                              </div>
                            </div>
                          </b-card-header>
                        </template>
                        <template #table-busy>
                          <b-card-header>
                            <div class="d-flex justify-content-center align-items-center">
                              <div class="preloader-component me-2">
                                <div class="status">
                                  <div class="spinner-chase w-20px h-20px">
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                  </div>
                                </div>
                              </div>
                              <strong>Loading...</strong>
                            </div>
                          </b-card-header>
                        </template>
                        <template #cell(poNumber)="row">
                          <b-card-header header-tag="header" @click="getProperty(row)" class="cursor-pointer border"
                            role="tab">
                            <div class="d-flex justify-content-between align-items-center">
                              <div>
                                <b class="text-white">{{
                                  row.value
                                    ? `PO# ${row.value}`
                                    : "No Recorded PO"
                                }}</b>
                                <div>
                                  {{
                                    row.item.supplier
                                      ? row.item.supplier
                                      : "No Recorded Supplier"
                                  }}
                                </div>
                              </div>
                              <div>
                                <i class="bx bx-chevron-right rotate font-size-16 cursor-pointer" :class="{
                                  'rotate-90': row.item.rotateChevy
                                }"></i>
                              </div>
                            </div>
                          </b-card-header>
                          <b-collapse :visible="row.item.showDetails">
                            <div v-if="row.item.showDetails">
                              <b-card no-body
                                class="p-3 shadow-none mb-0 border-5 border-top-0 border-start-0 border-end-0">
                                <div>
                                  <div class="d-flex align-items-center float-end mb-2">
                                    <b-button title="Add Visible Properties to Cart" class="btn-sm me-1" @click="
                                      addAllToCart(
                                        propertyFiltered(row.item),
                                        row.item.currentPage,
                                        row.item.perPage
                                      )
                                      " variant="outline-info"><i class="mdi mdi-cart-outline"></i></b-button>
                                    <b-button title="Remove All from Cart" class="btn-sm" @click="
                                      removeAllFromCart(
                                        propertyFiltered(row.item),
                                        row.item.currentPage,
                                        row.item.perPage
                                      )
                                      " variant="outline-danger"><i class="mdi mdi-cart-remove"></i></b-button>
                                    <b-dropdown id="dropdown-dropleft" right variant="link"
                                      toggle-class="text-decoration-none" menu-class="dropdown-menu-end" no-caret>
                                      <template #button-content>
                                        <button type="button"
                                          class="btn btn-sm btn-purple d-flex align-items-center m-0">
                                          <i class="bx bx-printer fs-6 me-1"></i>Print Documents
                                        </button>
                                      </template>
                                      <b-dropdown-item v-if="
                                        checkPropertyType(row.item.details) ==
                                        1 ||
                                        checkPropertyType(
                                          row.item.details
                                        ) == 3
                                      " @click="
                                          employeeData
                                            ? printParPoAndEmployee(
                                              row.item.poNumber,
                                              employeeData.idNo
                                            )
                                            : printParPo(row.item.poNumber)
                                          "><i class="bx bx-printer font-size-18 text-purple me-1"></i>Print PAR by
                                        PO</b-dropdown-item>
                                      <b-dropdown-item v-if="
                                        checkPropertyType(row.item.details) ==
                                        2 ||
                                        checkPropertyType(
                                          row.item.details
                                        ) == 3
                                      " @click="
                                          employeeData
                                            ? printIcsPoAndEmployee(
                                              row.item.poNumber,
                                              employeeData.idNo
                                            )
                                            : printIcsPo(row.item.poNumber)
                                          "><i class="bx bx-printer font-size-18 text-purple me-1"></i>Print ICS by
                                        PO</b-dropdown-item>
                                      <b-dropdown-item><i class="bx bx-printer font-size-18 text-purple me-1"></i>Print
                                        RIS by
                                        PO</b-dropdown-item>
                                      <b-dropdown-item @click="
                                        printStickerPo(row.item.poNumber)
                                        "><i class="bx bx-printer font-size-18 text-purple me-1"></i>Print Sticker by
                                        PO</b-dropdown-item>
                                    </b-dropdown>
                                    <div id="tickets-table_filter" class="dataTables_filter me-1">
                                      <label class="d-inline-flex align-items-center mb-0">
                                        <b-form-input autocomplete="off" v-model="row.item.filter" type="search"
                                          placeholder="Search Property..."
                                          class="form-control form-control-sm"></b-form-input>
                                      </label>
                                    </div>
                                    <div id="tickets-table_length" class="dataTables_length">
                                      <label class="d-inline-flex align-items-center mb-0">
                                        <b-form-select class="form-select form-select-sm" v-model="row.item.perPage"
                                          size="sm" :options="pageOptionsSm">
                                        </b-form-select>
                                      </label>
                                    </div>
                                  </div>
                                </div>
                                <div class="mb-0">
                                  <b-table class="propertyTable datatables target-table" thead-class="d-none"
                                    :items="propertyFiltered(row.item)" :fields="propertyFields" responsive="sm"
                                    :per-page="row.item.perPage" :current-page="row.item.currentPage" sort-by="id"
                                    :sort-desc.sync="sortDesc" :busy="row.item.tableBusy" show-empty>
                                    <template #empty>
                                      <b-card-header>
                                        <div class="text-center">
                                          <div v-if="row.item.filter != ''">
                                            <i class="fas fa-exclamation-triangle me-2"></i>There are no properties
                                            matching
                                            your request
                                          </div>
                                          <div v-else>
                                            <i class="fas fa-exclamation-triangle me-2"></i>No properties available
                                          </div>
                                        </div>
                                      </b-card-header>
                                    </template>
                                    <template #table-busy>
                                      <b-card-header>
                                        <div class="d-flex justify-content-center align-items-center p-2">
                                          <div class="preloader-component me-2">
                                            <div class="status">
                                              <div class="spinner-chase w-20px h-20px">
                                                <div class="chase-dot"></div>
                                                <div class="chase-dot"></div>
                                                <div class="chase-dot"></div>
                                                <div class="chase-dot"></div>
                                                <div class="chase-dot"></div>
                                                <div class="chase-dot"></div>
                                              </div>
                                            </div>
                                          </div>
                                          <strong>Loading...</strong>
                                        </div>
                                      </b-card-header>
                                    </template>
                                    <template #cell(name)="propertyRow">
                                      <div class="position-relative ms-1">
                                        <RawData :data="propertyRow.item" :keyId="`search-filteredPo-${propertyRow.item.id}`
                                          " v-if="$store.state.decrypt.isAdmin()" />
                                      </div>
                                      <b-card-header header-tag="header" role="tab" class="border">
                                        <div class="d-flex justify-content-between align-items-center">
                                          <div class="d-flex align-items-center pe-5">
                                            <div :style="propertyNumberWidth(
                                              (row.item.currentPage - 1) *
                                              row.item.perPage +
                                              (propertyRow.index + 1)
                                            )
                                              " class="bg-success bg-gradient text-center me-2 py-1 position-relative">
                                              <h3 class="mb-0 position-relative">
                                                {{
                                                  (row.item.currentPage - 1) *
                                                  row.item.perPage +
                                                  (propertyRow.index + 1)
                                                }}
                                              </h3>
                                            </div>
                                            <div class="text-muted">
                                              <h5 class="mb-0">
                                                {{ propertyRow.item.name }}
                                              </h5>
                                              <div style="min-width: max-content">
                                                <small class="d-flex align-items-center">{{
                                                  propertyRow.item
                                                    .propertyNumber &&
                                                    propertyRow.item
                                                      .propertyNumber !=
                                                    "Not Indicated"
                                                    ? `Property# ${propertyRow.item.propertyNumber}`
                                                    : "Not Indicated"
                                                }}
                                                  |
                                                  <a href="javascript: void(0);"
                                                    class="text-success d-flex align-items-center ms-1" @click="
                                                      propertyRow.item.visible = !propertyRow
                                                        .item.visible
                                                      ">
                                                    {{
                                                      propertyRow.item.visible
                                                        ? "Hide"
                                                        : "Show"
                                                    }}
                                                    Details
                                                    <i class="bx bx-chevron-right rotate font-size-14" :class="{
                                                      'rotate-90':
                                                        propertyRow.item
                                                          .visible
                                                    }"></i>
                                                  </a>
                                                </small>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="d-flex justify-content-between align-items-center ms-5">
                                            <div style="width: 200px" class="d-flex align-items-center">
                                              <div class="text-muted">
                                                <div>
                                                  <small class="d-flex align-items-center">
                                                    Current Value:
                                                  </small>
                                                </div>
                                                <h6 class="mb-0 text-warning">
                                                  {{
                                                    formatCurrency(
                                                      propertyRow.item
                                                        .currentValue
                                                    )
                                                  }}
                                                </h6>
                                              </div>
                                            </div>
                                            <div class="float-end d-flex align-items-center ms-3">
                                              <i v-if="
                                                checkCart(propertyRow.item)
                                              " title="Add to Cart"
                                                class="mdi mdi-cart-outline font-size-18 text-info cursor-pointer me-1"
                                                @click="
                                                  addToCart(propertyRow.item)
                                                  "></i>
                                              <i v-else title="Remove from Cart"
                                                class="mdi mdi-cart-remove font-size-18 text-danger cursor-pointer me-1"
                                                @click="
                                                  removeFromCart(
                                                    propertyRow.item
                                                  )
                                                  "></i>
                                              <i class="bx bx-printer font-size-18 text-purple cursor-pointer ms-2" :id="`all-print-popover-${propertyRow.item.id}`
                                                " tabindex="0"></i>
                                              <b-popover :target="`all-print-popover-${propertyRow.item.id}`
                                                " triggers="click blur" placement="leftbottom" variant="secondary"
                                                custom-class="p-0">
                                                <b-list-group class="w-100 fit">
                                                  <b-list-group-item v-if="
                                                    propertyRow.item.amount >=
                                                    50000
                                                  " button action class="d-flex align-items-center" @click="
                                                      printParProperty(
                                                        propertyRow.item.id
                                                      )
                                                      "><i class="bx bx-printer text-purple font-size-18 me-1"></i>Print
                                                    PAR</b-list-group-item>
                                                  <b-list-group-item v-else button action
                                                    class="d-flex align-items-center" @click="
                                                      printIcsProperty(
                                                        propertyRow.item.id
                                                      )
                                                      "><i class="bx bx-printer text-purple font-size-18 me-1"></i>Print
                                                    ICS</b-list-group-item>
                                                  <b-list-group-item button action class="d-flex align-items-center"
                                                    @click="
                                                      printStickerProperty(
                                                        propertyRow.item.id
                                                      )
                                                      "><i class="bx bx-printer text-purple font-size-18 me-1"></i>Print
                                                    Sticker</b-list-group-item>
                                                  <b-list-group-item button action class="d-flex align-items-center"
                                                    @click="
                                                      printPropertyCard(
                                                        propertyRow.item.id
                                                      )
                                                      "><i class="bx bx-printer text-purple font-size-18 me-1"></i>Print
                                                    Property Card</b-list-group-item>
                                                </b-list-group>
                                              </b-popover>
                                              <i class="fas fa-ellipsis-v cursor-pointer ps-2 pe-2 ms-2" :id="`all-popover-${propertyRow.item.id}`
                                                " tabindex="0"></i>
                                              <b-popover :target="`all-popover-${propertyRow.item.id}`
                                                " triggers="click blur" placement="leftbottom" variant="secondary"
                                                custom-class="p-0">
                                                <b-list-group class="w-100 fit">
                                                  <b-list-group-item button action
                                                    class="d-flex align-items-center text-info" @click="
                                                      updateItem(
                                                        propertyRow.item,
                                                        row.item
                                                      )
                                                      "><i class="mdi mdi-update font-size-18 me-1"></i>Update
                                                    Item</b-list-group-item>
                                                </b-list-group>
                                              </b-popover>
                                            </div>
                                          </div>
                                        </div>
                                      </b-card-header>
                                      <b-collapse :visible="propertyRow.item.visible" role="tabpanel">
                                        <div v-if="propertyRow.item.visible">
                                          <b-card no-body
                                            class="shadow-none mb-0 border-5 border-top-0 border-start-0 border-end-0">
                                            <Details :key="`all-details-${propertyRow.item.id}`
                                              " :propertyRow="propertyRow.item" :ref="`all-details-${propertyRow.item.id}`
                                                "></Details>
                                            <AssignmentHistory :key="`all-assignment-${propertyRow.item.id}`
                                              " :propertyRow="propertyRow.item" :allowAssign="false" :allowEdit="true"
                                              :allowTransfer="true" :employeeData="assignmentHistoryEmployeeData
                                                " :locationData="assignmentHistoryLocationData
                                                " :ref="`all-assignment-${propertyRow.item.id}`
                                                " @getEmployee="getEmployee($event)" @getLocation="getLocation($event)">
                                            </AssignmentHistory>
                                            <CurrentInventory :key="`all-inventory-${propertyRow.item.id}`
                                              " :propertyRow="propertyRow.item" :ref="`all-inventory-${propertyRow.item.id}`
                                                "></CurrentInventory>
                                            <InspectionHistory :key="`all-inspection-${propertyRow.item.id}`
                                              " :propertyRow="propertyRow.item" :ref="`all-inspection-${propertyRow.item.id}`
                                                "></InspectionHistory>
                                            <Attachments :key="`all-attachments-${propertyRow.item.id}`
                                              " :propertyRow="propertyRow.item" :ref="`all-attachments-${propertyRow.item.id}`
                                                "></Attachments>
                                          </b-card>
                                        </div>
                                      </b-collapse>
                                    </template>
                                  </b-table>
                                </div>
                                <div class="row">
                                  <div v-if="propertyRows(row.item) > 0" class="col">
                                    Showing
                                    {{
                                      (row.item.currentPage - 1) *
                                      row.item.perPage +
                                      1
                                    }}
                                    -
                                    {{
                                      propertyRows(row.item) >
                                        (row.item.currentPage - 1) *
                                        row.item.perPage +
                                        row.item.perPage
                                        ? (row.item.currentPage - 1) *
                                        row.item.perPage +
                                        row.item.perPage
                                        : propertyRows(row.item)
                                    }}
                                    of {{ propertyRows(row.item) }}
                                  </div>
                                  <div class="col">
                                    <div class="dataTables_paginate paging_simple_numbers float-end">
                                      <ul class="pagination pagination-rounded mb-0" style="z-index: -1">
                                        <b-pagination v-model="row.item.currentPage"
                                          :total-rows="propertyRows(row.item)"
                                          :per-page="row.item.perPage"></b-pagination>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </b-card>
                            </div>
                          </b-collapse>
                        </template>
                      </b-table>
                    </div>
                    <div class="row">
                      <div v-if="rows > 0" class="col">
                        Showing {{ (currentPage - 1) * perPage + 1 }} -
                        {{
                          rows > (currentPage - 1) * perPage + perPage
                            ? (currentPage - 1) * perPage + perPage
                            : rows
                        }}
                        of {{ rows }}
                      </div>
                      <div class="col">
                        <div class="dataTables_paginate paging_simple_numbers float-end">
                          <ul class="pagination pagination-rounded mb-0" style="z-index: -1">
                            <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </div>
          <div v-if="byAll">
            <div class="card border-4 border-top border-start-0 border-end-0 border-primary">
              <div class="card-body">
                <div class="row mb-1">
                  <div class="col-md-6">
                    <div>
                      <h5 class="m-0 mb-1">List of Properties</h5>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="d-flex float-end align-items-center">
                      <div id="tickets-table_filter" class="dataTables_filter me-1">
                        <label class="d-inline-flex align-items-center mb-0">
                          <b-form-input autocomplete="off" v-model="filter" type="search" @input="currentPage = 1"
                            placeholder="Search PO..." class="form-control"></b-form-input>
                        </label>
                      </div>
                      <div id="tickets-table_length" class="dataTables_length">
                        <label class="d-inline-flex align-items-center mb-0">
                          <b-form-select class="form-select" v-model="perPage" size="sm" :options="pageOptionsLg">
                          </b-form-select>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="custom-table-responsive mb-0 mt-2">
                  <b-table class="propertyTable datatables target-table" :items="grouped" :fields="fields"
                    responsive="sm" :per-page="perPage" :current-page="currentPage" :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc" :busy="tableBusy" bordered outlined striped show-empty>
                    <template #empty>
                      <b-card-header>
                        <div class="text-center">
                          <div v-if="filter != ''">
                            <i class="fas fa-exclamation-triangle me-2"></i>There are no POs matching your request
                          </div>
                          <div v-else>
                            <i class="fas fa-exclamation-triangle me-2"></i>No
                            properties available
                          </div>
                        </div>
                      </b-card-header>
                    </template>
                    <template #table-busy>
                      <b-card-header>
                        <div class="d-flex justify-content-center align-items-center">
                          <div class="preloader-component me-2">
                            <div class="status">
                              <div class="spinner-chase w-20px h-20px">
                                <div class="chase-dot"></div>
                                <div class="chase-dot"></div>
                                <div class="chase-dot"></div>
                                <div class="chase-dot"></div>
                                <div class="chase-dot"></div>
                                <div class="chase-dot"></div>
                              </div>
                            </div>
                          </div>
                          <strong>Loading...</strong>
                        </div>
                      </b-card-header>
                    </template>
                    <template #cell(poNumber)="row">
                      <b-card-header header-tag="header" @click="getProperty(row)" class="cursor-pointer border"
                        role="tab">
                        <div class="d-flex justify-content-between align-items-center">
                          <div>
                            <b class="text-white">{{
                              row.value ? `PO# ${row.value}` : "No Recorded PO"
                            }}</b>
                            <div>
                              {{
                                row.item.supplier
                                  ? row.item.supplier
                                  : "No Recorded Supplier"
                              }}
                            </div>
                          </div>
                          <div>
                            <i class="bx bx-chevron-right rotate font-size-16 cursor-pointer" :class="{
                              'rotate-90': row.item.rotateChevy
                            }"></i>
                          </div>
                        </div>
                      </b-card-header>
                      <b-collapse :visible="row.item.showDetails">
                        <div v-if="row.item.showDetails">
                          <b-card no-body
                            class="p-3 shadow-none mb-0 border-5 border-top-0 border-start-0 border-end-0">
                            <div>
                              <div class="d-flex align-items-center float-end mb-2">
                                <b-button title="Add Visible Properties to Cart" class="btn-sm me-1" @click="
                                  addAllToCart(
                                    propertyFiltered(row.item),
                                    row.item.currentPage,
                                    row.item.perPage
                                  )
                                  " variant="outline-info"><i class="mdi mdi-cart-outline"></i></b-button>
                                <b-button title="Remove All from Cart" class="btn-sm" @click="
                                  removeAllFromCart(
                                    propertyFiltered(row.item),
                                    row.item.currentPage,
                                    row.item.perPage
                                  )
                                  " variant="outline-danger"><i class="mdi mdi-cart-remove"></i></b-button>
                                <b-dropdown id="dropdown-dropleft" right variant="link"
                                  toggle-class="text-decoration-none" menu-class="dropdown-menu-end" no-caret>
                                  <template #button-content>
                                    <button type="button" class="btn btn-sm btn-purple d-flex align-items-center m-0">
                                      <i class="bx bx-printer fs-6 me-1"></i>Print Documents
                                    </button>
                                  </template>
                                  <b-dropdown-item v-if="
                                    checkPropertyType(row.item.details) ==
                                    1 ||
                                    checkPropertyType(row.item.details) == 3
                                  " @click="printParPo(row.item.poNumber)"><i
                                      class="bx bx-printer font-size-18 text-purple me-1"></i>Print PAR by
                                    PO</b-dropdown-item>
                                  <b-dropdown-item v-if="
                                    checkPropertyType(row.item.details) ==
                                    2 ||
                                    checkPropertyType(row.item.details) == 3
                                  " @click="printIcsPo(row.item.poNumber)"><i
                                      class="bx bx-printer font-size-18 text-purple me-1"></i>Print ICS by
                                    PO</b-dropdown-item>
                                  <b-dropdown-item><i class="bx bx-printer font-size-18 text-purple me-1"></i>Print RIS
                                    by PO</b-dropdown-item>
                                  <b-dropdown-item @click="printStickerPo(row.item.poNumber)"><i
                                      class="bx bx-printer font-size-18 text-purple me-1"></i>Print Sticker by
                                    PO</b-dropdown-item>
                                </b-dropdown>
                                <div id="tickets-table_filter" class="dataTables_filter me-1">
                                  <label class="d-inline-flex align-items-center mb-0">
                                    <b-form-input autocomplete="off" v-model="row.item.filter" type="search"
                                      placeholder="Search Property..."
                                      class="form-control form-control-sm"></b-form-input>
                                  </label>
                                </div>
                                <div id="tickets-table_length" class="dataTables_length">
                                  <label class="d-inline-flex align-items-center mb-0">
                                    <b-form-select class="form-select form-select-sm" v-model="row.item.perPage"
                                      size="sm" :options="pageOptionsSm">
                                    </b-form-select>
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div class="mb-0">
                              <b-table class="propertyTable datatables target-table" thead-class="d-none"
                                :items="propertyFiltered(row.item)" :fields="propertyFields" responsive="sm"
                                :per-page="row.item.perPage" :current-page="row.item.currentPage" sort-by="id"
                                :sort-desc.sync="sortDesc" :busy="row.item.tableBusy" show-empty>
                                <template #empty>
                                  <b-card-header>
                                    <div class="text-center">
                                      <div v-if="row.item.filter != ''">
                                        <i class="fas fa-exclamation-triangle me-2"></i>There are no properties matching
                                        your
                                        request
                                      </div>
                                      <div v-else>
                                        <i class="fas fa-exclamation-triangle me-2"></i>No properties available
                                      </div>
                                    </div>
                                  </b-card-header>
                                </template>
                                <template #table-busy>
                                  <b-card-header>
                                    <div class="d-flex justify-content-center align-items-center p-2">
                                      <div class="preloader-component me-2">
                                        <div class="status">
                                          <div class="spinner-chase w-20px h-20px">
                                            <div class="chase-dot"></div>
                                            <div class="chase-dot"></div>
                                            <div class="chase-dot"></div>
                                            <div class="chase-dot"></div>
                                            <div class="chase-dot"></div>
                                            <div class="chase-dot"></div>
                                          </div>
                                        </div>
                                      </div>
                                      <strong>Loading...</strong>
                                    </div>
                                  </b-card-header>
                                </template>
                                <template #cell(name)="propertyRow">
                                  <div class="position-relative ms-1">
                                    <RawData :data="propertyRow.item" :keyId="`all-${propertyRow.item.id4}`"
                                      v-if="$store.state.decrypt.isAdmin()" />
                                  </div>
                                  <b-card-header header-tag="header" role="tab" class="border">
                                    <div class="d-flex justify-content-between align-items-center">
                                      <div class="d-flex align-items-center pe-5">
                                        <div :style="propertyNumberWidth(
                                          (currentPage - 1) * perPage +
                                          (propertyRow.index + 1)
                                        )
                                          " class="bg-success bg-gradient text-center me-2 py-1 position-relative">
                                          <h3 class="mb-0 position-relative">
                                            {{
                                              (row.item.currentPage - 1) *
                                              row.item.perPage +
                                              (propertyRow.index + 1)
                                            }}
                                          </h3>
                                        </div>
                                        <div class="text-muted">
                                          <h5 class="mb-0">
                                            {{ propertyRow.item.name }}
                                          </h5>
                                          <div style="min-width: max-content">
                                            <small class="d-flex align-items-center">{{
                                              propertyRow.item
                                                .propertyNumber &&
                                                propertyRow.item
                                                  .propertyNumber !=
                                                "Not Indicated"
                                                ? `Property# ${propertyRow.item.propertyNumber}`
                                                : "Not Indicated"
                                            }}
                                              |
                                              <a href="javascript: void(0);"
                                                class="text-success d-flex align-items-center ms-1" @click="
                                                  propertyRow.item.visible = !propertyRow
                                                    .item.visible
                                                  ">
                                                {{
                                                  propertyRow.item.visible
                                                    ? "Hide"
                                                    : "Show"
                                                }}
                                                Details
                                                <i class="bx bx-chevron-right rotate font-size-14" :class="{
                                                  'rotate-90':
                                                    propertyRow.item.visible
                                                }"></i>
                                              </a>
                                            </small>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="d-flex justify-content-between align-items-center ms-5">
                                        <div style="width: 200px" class="d-flex align-items-center">
                                          <div class="text-muted">
                                            <div>
                                              <small class="d-flex align-items-center">
                                                Current Value:
                                              </small>
                                            </div>
                                            <h6 class="mb-0 text-warning">
                                              {{
                                                formatCurrency(
                                                  propertyRow.item.currentValue
                                                )
                                              }}
                                            </h6>
                                          </div>
                                        </div>
                                        <div class="float-end d-flex align-items-center ms-3">
                                          <i v-if="checkCart(propertyRow.item)" title="Add to Cart"
                                            class="mdi mdi-cart-outline font-size-18 text-info cursor-pointer me-1"
                                            @click="addToCart(propertyRow.item)"></i>
                                          <i v-else title="Remove from Cart"
                                            class="mdi mdi-cart-remove font-size-18 text-danger cursor-pointer me-1"
                                            @click="
                                              removeFromCart(propertyRow.item)
                                              "></i>
                                          <i class="bx bx-printer font-size-18 text-purple cursor-pointer ms-2" :id="`all-print-popover-${propertyRow.item.id}`
                                            " tabindex="0"></i>
                                          <b-popover :target="`all-print-popover-${propertyRow.item.id}`
                                            " triggers="click blur" placement="leftbottom" variant="secondary"
                                            custom-class="p-0">
                                            <b-list-group class="w-100 fit">
                                              <b-list-group-item v-if="
                                                propertyRow.item.amount >=
                                                50000
                                              " button action class="d-flex align-items-center" @click="
                                                  printParProperty(
                                                    propertyRow.item.id
                                                  )
                                                  "><i class="bx bx-printer text-purple font-size-18 me-1"></i>Print
                                                PAR</b-list-group-item>
                                              <b-list-group-item v-else button action class="d-flex align-items-center"
                                                @click="
                                                  printIcsProperty(
                                                    propertyRow.item.id
                                                  )
                                                  "><i class="bx bx-printer text-purple font-size-18 me-1"></i>Print
                                                ICS</b-list-group-item>
                                              <b-list-group-item button action class="d-flex align-items-center" @click="
                                                printStickerProperty(
                                                  propertyRow.item.id
                                                )
                                                "><i class="bx bx-printer text-purple font-size-18 me-1"></i>Print
                                                Sticker</b-list-group-item>
                                              <b-list-group-item button action class="d-flex align-items-center" @click="
                                                printPropertyCard(
                                                  propertyRow.item.id
                                                )
                                                "><i class="bx bx-printer text-purple font-size-18 me-1"></i>Print
                                                Property Card</b-list-group-item>
                                            </b-list-group>
                                          </b-popover>
                                          <i class="fas fa-ellipsis-v cursor-pointer ps-2 pe-2 ms-2" :id="`all-popover-${propertyRow.item.id}`
                                            " tabindex="0"></i>
                                          <b-popover :target="`all-popover-${propertyRow.item.id}`
                                            " triggers="click blur" placement="leftbottom" variant="secondary"
                                            custom-class="p-0">
                                            <b-list-group class="w-100 fit">
                                              <b-list-group-item button action
                                                class="d-flex align-items-center text-info" @click="
                                                  updateItem(
                                                    propertyRow.item,
                                                    row.item
                                                  )
                                                  "><i class="mdi mdi-update font-size-18 me-1"></i>Update
                                                Item</b-list-group-item>
                                            </b-list-group>
                                          </b-popover>
                                        </div>
                                      </div>
                                    </div>
                                  </b-card-header>
                                  <b-collapse :visible="propertyRow.item.visible" role="tabpanel">
                                    <div v-if="propertyRow.item.visible">
                                      <b-card no-body
                                        class="shadow-none mb-0 border-5 border-top-0 border-start-0 border-end-0">
                                        <Details :key="`all-details-${propertyRow.item.id}`
                                          " :propertyRow="propertyRow.item" :ref="`all-details-${propertyRow.item.id}`
                                            "></Details>
                                        <AssignmentHistory :key="`all-assignment-${propertyRow.item.id}`
                                          " :propertyRow="propertyRow.item" :allowAssign="false" :allowEdit="true"
                                          :allowTransfer="true" :employeeData="assignmentHistoryEmployeeData
                                            " :locationData="assignmentHistoryLocationData
                                            " :ref="`all-assignment-${propertyRow.item.id}`
                                            " @getEmployee="getEmployee($event)" @getLocation="getLocation($event)">
                                        </AssignmentHistory>
                                        <CurrentInventory :key="`all-inventory-${propertyRow.item.id}`
                                          " :propertyRow="propertyRow.item" :ref="`all-inventory-${propertyRow.item.id}`
                                            "></CurrentInventory>
                                        <InspectionHistory :key="`all-inspection-${propertyRow.item.id}`
                                          " :propertyRow="propertyRow.item" :ref="`all-inspection-${propertyRow.item.id}`
                                            "></InspectionHistory>
                                        <Attachments :key="`all-attachments-${propertyRow.item.id}`
                                          " :propertyRow="propertyRow.item" :ref="`all-attachments-${propertyRow.item.id}`
                                            "></Attachments>
                                      </b-card>
                                    </div>
                                  </b-collapse>
                                </template>
                              </b-table>
                            </div>
                            <div class="row">
                              <div v-if="propertyRows(row.item) > 0" class="col">
                                Showing
                                {{
                                  (row.item.currentPage - 1) *
                                  row.item.perPage +
                                  1
                                }}
                                -
                                {{
                                  propertyRows(row.item) >
                                    (row.item.currentPage - 1) *
                                    row.item.perPage +
                                    row.item.perPage
                                    ? (row.item.currentPage - 1) *
                                    row.item.perPage +
                                    row.item.perPage
                                    : propertyRows(row.item)
                                }}
                                of {{ propertyRows(row.item) }}
                              </div>
                              <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-end">
                                  <ul class="pagination pagination-rounded mb-0" style="z-index: -1">
                                    <b-pagination v-model="row.item.currentPage" :total-rows="propertyRows(row.item)"
                                      :per-page="row.item.perPage"></b-pagination>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </b-card>
                        </div>
                      </b-collapse>
                    </template>
                  </b-table>
                </div>
                <div class="row">
                  <div v-if="rows > 0" class="col">
                    Showing {{ (currentPage - 1) * perPage + 1 }} -
                    {{
                      rows > (currentPage - 1) * perPage + perPage
                        ? (currentPage - 1) * perPage + perPage
                        : rows
                    }}
                    of {{ rows }}
                  </div>
                  <div class="col">
                    <div class="dataTables_paginate paging_simple_numbers float-end">
                      <ul class="pagination pagination-rounded mb-0" style="z-index: -1">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <!-- View Cart -->
    <transition name="fade">
      <div v-if="selectedProperties.length > 0" @mouseenter="mouseOverCart = true" @mouseleave="mouseOverCart = false"
        class="position-fixed" style="bottom: 20px; left: 50px">
        <span class="badge bg-danger rounded-pill position-fixed" style="bottom: 55px; left: 85px">
          {{ selectedProperties.length }}
        </span>
        <div title="View Cart" class="avatar-sm mx-auto cursor-pointer" @click="showCart()">
          <span class="avatar-title rounded-circle bg-info">
            <i 
              class="mdi mdi-cart-outline font-size-24" 
              :class="{ 'bx-tada': mouseOverCart == true }"
            >
            </i>
          </span>
        </div>
      </div>
    </transition>
    <fund-cluster ref="fundcluster" @dropData="dropFundCluster($event)"></fund-cluster>
    <item-category ref="itemcategory" @dropData="dropItemCat($event)"></item-category>
    <supplier @dropData="dropSupplier($event)"></supplier>
    <unit ref="unit" @dropData="dropUnit($event)"></unit>
    <Employee ref="employee" @dropData="dropEmployee($event)"></Employee>
    <Location ref="location" @dropData="dropLocation($event)"></Location>
    <Campus ref="campus" @dropData="dropCampus($event)"></Campus>
    <PropertyUpdate ref="propertyupdate" @updateData="onUpdateItem($event)" @getFundCluster="getFundCluster($event)"
      @getItemCategory="getItemCategory($event)" @getSupplier="getSupplier($event)" @getUnit="getUnit($event)">
    </PropertyUpdate>
    <Inventory ref="inventory" @dropData="dropInventory($event)"></Inventory>
    <print-options ref="printOpt"></print-options>
  </Layout>
</template>

<style>
.p-0 .popover-body {
  padding: 0 !important;
}

.tooltip {
  opacity: 1 !important;
}

.slide-enter-active {
  animation: slide-in 0.25s;
}

.slide-leave-active {
  animation: slide-in 0.25s reverse;
}

.fade-enter-active {
  animation: fade-in 0.5s;
}

.fade-leave-active {
  animation: fade-in 0.5s reverse;
}

@keyframes fade-in {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@keyframes slide-in {
  0% {
    transform: translateX(-20px);
    opacity: 0;
  }

  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

.propertyTable tr td {
  padding: 0 !important;
  margin: 0 !important;
}

.btn.focus,
.btn:focus {
  outline: 0;
  box-shadow: 0 0 0 0 !important;
}
</style>
